/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../assets/Icons/index.js";
import BalanceSummary from "../../components/_utils/CommonBalanceSummary/index.jsx";
import PrimaryWithIconButton from "../../components/_utils/CommonButtons/PrimaryWithIconButton/index.jsx";
import SmallAlertPopup from "../../components/_utils/CommonPopups/CommonAlertPopup";
import SmallAnnocementsPopup from "../../components/_utils/CommonPopups/CommonAnnocementsPopup/index.jsx";
import SmallReminderPopup from "../../components/_utils/CommonPopups/CommonReminderPopup/index.jsx";
import CommonToast from "../../components/_utils/CommonToast/index.jsx";
import MultiEntityBanner from "../../components/_utils/MultiEntityBanner";
import SVGComponent from "../../components/_utils/SVGComponent/index.jsx";
import HolidayCard from "../../components/HomeDashboard/HolidayCard/index.jsx";
import { setHideBreadCrumb } from "../../redux/features/hideBreadCrumb/hideBreadCrumb";
import {
  getHolidays,
  toggleCalendar,
} from "../../redux/features/holidays/index.js";
// import { reimbursementTxnViewAll } from "../../redux/features/reimbursementTransaction/index.js";
// import { reimbursementRequestApproval } from "../../redux/features/reimbursementRequest/index.js";
import { remitterAccountViewAll } from "../../redux/features/accounts/remitterAccount/remitterAccount.js";
// import { ReimburseViewAllHomeDashboard } from "../../redux/features/accounts/ReimburseAccount/index.js";
import CommonAlertCard from "../../components/_utils/CommonAlertCard/index.jsx";
import SmallPopupWithBulletPoints from "../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import { getAllBeneficiaryAccounts } from "../../redux/features/accounts/beneficiaryAccount/index.js";
import { getAllInternalAccounts } from "../../redux/features/accounts/internalAccount/index.js";
import { ReimburseViewAll } from "../../redux/features/accounts/ReimburseAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { setshowsuccestoast } from "../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { reminderTxnView } from "../../redux/features/reminderTransaction";
import { toast_position } from "../../redux/features/Settings/Authorization";
import { fetchWidgets } from "../../redux/features/Settings/Statistics";
import { getAllCategories } from "../../redux/features/sharedResources/sharedResources.js";
import { beneficiaryTransactionsViewAll } from "../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  internalTransactionsViewAll,
  resetInternalTransactionsViewAll,
} from "../../redux/features/transactions/internalTransactions/index.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../utils/bankingHours.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../utils/configurationProvider.js";
import "./index.css";
import { renderWidget, WIDGET_TITLES } from "./Widgets/WidgetRegistry.jsx";

const HomeDashboard = () => {
  // const [showBanner, setShowBanner] = useState(true);
  const [showOutsideBankingBanner, setShowOutsideBankingBanner] =
    useState(false);
  const [isOutsideBankingHoursActive, setIsOutsideBankingHoursActive] =
    useState(isOutsideBankingHours());
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const services = useSelector((state) => state.refreshToken.services);
  const userData = useSelector((state) => state.refreshToken.data);

  const [alertCount, setAlertCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const currentPage = GlobalConfiguration.lengthCheckOne;

  const [currentSlide, setCurrentSlide] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  // Track which widget slides have been opened by the user (will only call API if user have visited that slide)
  const [widgets, setWidgets] = useState([]);
  const slideRefs = useRef([]);
  const [containerHeight, setContainerHeight] = useState("auto");
  const currentWidget = widgets[currentSlide];
  const [visitedWidgetSlides, setVisitedWidgetSlides] = useState(
    new Set([GlobalConfiguration.lengthCheckZero]),
  );
  const dynamicTitle = WIDGET_TITLES[currentWidget?.widget_id] || "Statistics";
  const [loading, setLoading] = useState(true);

  const [activeLabel, setActiveLabel] = useState(null);

  // multi-level state for transactions slides
  const [txnActiveLevel, setTxnActiveLevel] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [txnLevel1Key, setTxnLevel1Key] = useState(null);
  const [txnLevel2Key, setTxnLevel2Key] = useState(null);
  const [level1ActiveSlide, setLevel1ActiveSlide] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [level2ActiveSlide, setLevel2ActiveSlide] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  const [isCalendarOpen, setIsCalendarOpen] = useState(null);

  const [hasFetchedCount, setHasFetchedCount] = useState(false);
  const [txnCountLoading, setTxnCountLoading] = useState(false);
  const [openMessagePanel, setOpenMessagePanel] = useState(null);
  const [openAccountSlider, setOpenAccountSlider] = useState(null);
  const [accountCountLoading, setAccountCountLoading] = useState(false);
  const [filteredBeneAccountsCount, setFilteredBeneAccountsCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [fieldForceAccountsCount, setFieldForceAccountsCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  const [showModal, setShowModal] = useState(false);
  const [selectedTxnData, setSelectedTxnData] = useState(null);

  const hasModService = services?.includes("AReminder");
  const viewAllReminderService = services?.includes("VReminder");

  const hasCreateService = services?.includes("CBeneficiaryTxn");
  const hasCreateInternalService = services?.includes("CInternalTxn");

  const [isReminderPopupOpen, setIsReminderPopupOpen] = useState(false);
  const [isAnnouncementPopupOpen, setIsAnnouncementPopupOpen] = useState(false);

  const [reimbursementAccountsCount, setReimbursementAccountsCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const { ownerAccBalanceLoading, showSuccessToast } = useSelector(
    (state) => state.ownerAllVerification,
  );

  const { remitterAccountViewAllData, remitterAccountViewAllLoading } =
    useSelector((state) => state.remitterAccount);

  const { allfieldForceAccountData, allfieldForceAccountLoading } = useSelector(
    (state) => state.fieldForceAccount,
  );

  const {
    beneficiaryTransactionsViewAllData,
    beneficiaryTransactionsViewAllLoading,
  } = useSelector((state) => state.beneficiaryTransactions);

  const { getAllInternalAccountLoading, getAllInternalAccountData } =
    useSelector((state) => state?.internalAccount);

  const { getAllBeneficiaryAccountsLoading, getAllBeneficiaryAccountsData } =
    useSelector((state) => state.beneficiaryAccount);

  const {
    internalTransactionsViewAllData,
    internalTransactionsViewAllLoading,
  } = useSelector((state) => state?.internalTransactions);

  // const { reimbursementTxnViewAllData, reimbursementTxnViewAllLoading } =
  //   useSelector((state) => state?.reimbursementTransaction);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const { fieldForceTxnViewAllData, fieldForceTxnViewAllLoading } = useSelector(
    (state) => state.fieldForceTransaction,
  );

  const { fieldForceRequestApprovalData, fieldForceRequestApprovalLoading } =
    useSelector((state) => state.fieldForceRequest);

  // const { allPrivateTransactionsData, allPrivateTransactionsLoading } =
  //   useSelector((state) => state.privatetransactions);

  // const {
  //   ReimburseViewAllHomeDashboardLoading,
  //   ReimburseViewAllHomeDashboardData,
  // } = useSelector((state) => state.ReimburseAccount);

  const categoriesData = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  const reminderTxnViewLoading = useSelector(
    (state) => state.reminderTxnSlice.reminderTxnViewLoading,
  );
  const reminderTxnViewData = useSelector(
    (state) => state.reminderTxnSlice.reminderTxnViewData,
  );

  const entityHasBeenChanged = markerData;
  // const {
  //   reimbursementRequestApprovalData,
  //   reimbursementRequestApprovalLoading,
  // } = useSelector((state) => state.reimbursementRequest);

  const holidaysList = useSelector(
    (state) => state.holidays?.holidaysList || [],
  );

  const beneficiaryAccountCount =
    getAllBeneficiaryAccountsData?.summary?.pending_accounts_count;

  const beneficiaryTxnCount =
    beneficiaryTransactionsViewAllData?.summary?.actionable_transaction_count;

  const internalAccountCount =
    getAllInternalAccountData?.summary?.pending_accounts_count;

  const remitterAccountCount =
    remitterAccountViewAllData?.summary?.pending_accounts_count;

  const fieldForceAccountCount =
    allfieldForceAccountData?.summary?.pending_accounts_count;

  // const reimbursementAccCount =
  //   ReimburseViewAllHomeDashboardData?.summary?.pending_accounts_count;

  const internalTxnCount =
    internalTransactionsViewAllData?.summary?.actionable_transaction_count;

  // const reimbursementTxnCount =
  //   reimbursementTxnViewAllData?.summary?.actionable_transaction_count;

  // const reimbursementRequestCount =
  //   reimbursementRequestApprovalData?.total_count;

  // const fieldForceTnxCount =
  //   fieldForceTxnViewAllData?.summary?.actionable_transaction_count;

  // const fieldForceRequestTnxCount = fieldForceRequestApprovalData?.total_count;

  // const privateTnxCount =
  //   allPrivateTransactionsData?.summary?.transaction_summary
  //     ?.actionable_transaction_count;

  // const taxTransactionCount =
  //   taxTransactionViewAllData?.summary?.actionable_transaction_count;

  useEffect(() => {
    const updateBankingHoursStatus = () => {
      const nextStatus = isOutsideBankingHours();
      setIsOutsideBankingHoursActive((prev) =>
        prev === nextStatus ? prev : nextStatus,
      );
    };

    updateBankingHoursStatus();
    const intervalId = setInterval(
      updateBankingHoursStatus,
      IntervalConfiguration.intervalMedium,
    );

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!isOutsideBankingHoursActive) {
      setShowOutsideBankingBanner(false);
    }
  }, [isOutsideBankingHoursActive]);

  const outsideBankingHoursLabel = getOutsideBankingHoursLabel();
  const navDetails = {
    txnDetails: {
      reminderRemark: selectedTxnData?.reminderRemark,
      reminderAmount: selectedTxnData?.reminderAmount || "",
    },
    flowType: "ReminderFlow",
  };
  const announcementData = [
    {
      id: 1,
      title: "Scheduled Maintenance Notice",
      announcement_date: "10 Aug, 2025",
      description:
        "Our services will be unavailable on 30th June from 1:00 AM to 4:00 AM IST due to maintenance. Our services will be unavailable on 30th June from 1:00 AM to 4:00 AM IST due to maintenance.Our services will be unavailable on 30th June from 1:00 AM to 4:00 AM IST due to maintenance.",
      created_by_name: "xxxxxxx",
      created_on: 1751522173,
    },
  ];

  const holidays = useMemo(() => holidaysList?.holidays || [], [holidaysList]);

  const doPageInit = useCallback(async () => {
    dispatch(setHideBreadCrumb({ hide: true }));
    dispatch(getHolidays());

    try {
      await Promise.allSettled([
        dispatch(reminderTxnView({ search_string: "current" })),
        dispatch(
          beneficiaryTransactionsViewAll({
            page_no: GlobalConfiguration.lengthCheckOne,
            page_item_count: PaginationConfiguration.paginationSmall,
          }),
        ),
        dispatch(
          getAllBeneficiaryAccounts({
            page_no: GlobalConfiguration.lengthCheckOne,
            page_size: PaginationConfiguration.paginationSmall,
            approval_status: ["pending", "approved"],
          }),
        ),

        dispatch(
          internalTransactionsViewAll({
            page_no: GlobalConfiguration.lengthCheckOne,
            page_item_count: PaginationConfiguration.paginationSmall,
          }),
        ),
        dispatch(
          getAllInternalAccounts({
            page_no: GlobalConfiguration.lengthCheckOne,
            page_size: PaginationConfiguration.paginationSmall,
            approval_status: ["pending", "approved"],
          }),
        ),
        dispatch(
          remitterAccountViewAll({
            page_no: GlobalConfiguration?.lengthCheckOne,
            page_size: PaginationConfiguration?.paginationSmall,
            approval_status: ["pending", "approved"],
          }),
        ),

        // dispatch(
        //   getAllFieldForceAccount({
        //     page_no: GlobalConfiguration?.lengthCheckOne,
        //     page_size: PaginationConfiguration?.paginationSmall,
        //     showToast: false,
        //   }),
        // ),

        // dispatch(
        //   ReimburseViewAllHomeDashboard({
        //     page: GlobalConfiguration.lengthCheckOne,
        //     page_size: PaginationConfiguration?.paginationSmall,
        //   }),
        // ),

        // dispatch(
        //   reimbursementTxnViewAll({
        //     page_no: GlobalConfiguration.lengthCheckOne,
        //     page_size: PaginationConfiguration.paginationSmall,
        //   }),
        // ),

        // dispatch(
        //   reimbursementRequestApproval({
        //     entityId: markerData?.entity_id,
        //   }),
        // ),

        // dispatch(
        //   approveFieldForceRequest({
        //     entityId: markerData?.entity_id,
        //   }),
        // ),

        // dispatch(
        //   getAllfieldForceTxn({
        //     page_no: GlobalConfiguration.lengthCheckOne,
        //     page_size: PaginationConfiguration.paginationSmall,
        //   }),
        // ),

        // dispatch(
        //   getAllPrivateTransactions({
        //     page_no: GlobalConfiguration.lengthCheckOne,
        //     page_size: PaginationConfiguration.paginationSmall,
        //   }),
        // ),
        // dispatch(
        //   taxTransactionViewAll({
        //     page_no: GlobalConfiguration.lengthCheckOne,
        //     page_size: PaginationConfiguration.paginationSmall,
        //   }),
        // ),
      ]);
    } catch (error) {
      setTimeout(() => {
        setAccountCountLoading(false);
        setTxnCountLoading(false);
      }, errorcode.errorFailed);
    }
  }, [dispatch, currentPage, markerData]);

  const doPageDestroy = useCallback(() => {
    dispatch(resetInternalTransactionsViewAll());
    dispatch(setHideBreadCrumb({ hide: false }));
  }, [dispatch]);

  // Mount/unmount
  useEffect(() => {
    dispatch(enableSwitcher());
    doPageInit();
    return () => {
      doPageDestroy();
      dispatch(disableSwitcher());
    };
  }, [dispatch, doPageInit, doPageDestroy]);

  // 1. Fetch saved widgets from Backend
  useEffect(() => {
    if (services?.includes("VStatistics")) {
      const fetchUserWidgets = async () => {
        setLoading(true);
        const res = await dispatch(fetchWidgets());
        if (fetchWidgets.fulfilled.match(res)) {
          if (Array.isArray(res?.payload?.widgets)) {
            // Filter out any widget_id not present in WIDGET registry.
            const validWidgets = res?.payload?.widgets?.filter((widget) => {
              return Boolean(WIDGET_TITLES[widget.widget_id]);
            });

            setWidgets(validWidgets || []);
          }
        }
        setLoading(false);
      };
      fetchUserWidgets();
    } else if (services) {
      setLoading(false);
    }
  }, [services, dispatch]);

  // Update visited widget slides set whenever the active slide changes
  useEffect(() => {
    if (widgets.length > GlobalConfiguration.lengthCheckZero) {
      setVisitedWidgetSlides((prev) => new Set(prev).add(currentSlide));
    }
  }, [currentSlide, widgets.length]);

  useEffect(() => {
    const activeSlideWrapper = slideRefs.current[currentSlide];
    if (!activeSlideWrapper) return;

    const contentElement =
      activeSlideWrapper.firstElementChild || activeSlideWrapper;

    const updateHeight = () => {
      if (contentElement) {
        // Get exact height of the rendered widget content
        const height = contentElement.getBoundingClientRect().height;
        if (height > GlobalConfiguration.lengthCheckZero) {
          setContainerHeight(`${height}px`);
        }
      }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });

    resizeObserver.observe(contentElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [currentSlide, widgets, visitedWidgetSlides]);

  // Refresh when entity changes
  useEffect(() => {
    if (entityHasBeenChanged) {
      doPageDestroy();
      doPageInit();
    }
  }, [entityHasBeenChanged, doPageInit, doPageDestroy]);

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const fetchAccountData = async (categories, currentPage) => {
    try {
      const response = await dispatch(
        getAllBeneficiaryAccounts({
          page_no: currentPage,
          approval_status: ["pending", "approved", "rejected"],
          category_ids: Array.isArray(categories) ? categories : [categories],
        }),
      );
      const response1 = await dispatch(
        ReimburseViewAll({
          page_no: currentPage,
          category: categories,
          approval_status: ["pending", "approved", "rejected"],
          type: "homeDashboard",
        }),
      );

      // const response2 = await dispatch(
      //   getAllFieldForceAccount({
      //     page_no: currentPage,
      //     approval_status: ["pending", "rejected", "approved"],
      //     // category: categories,
      //     showToast: false,
      //   }),
      // );

      const data = response?.payload;
      const data1 = response1?.payload;
      // const data2 = response2?.payload;

      if (data?.status === true) {
        setFilteredBeneAccountsCount(response?.payload?.total_count);
        // const accounts = data?.beneficiary_accounts || [];

        // const beneficiaryOnlyCount = accounts.filter(
        //   (acc) => acc?.reimbursement_account !== "Y",
        // ).length;

        // if (currentPage === GlobalConfiguration.lengthCheckOne) {
        //   setFilteredBeneAccountsCount(beneficiaryOnlyCount);
        // } else {
        //   setFilteredBeneAccountsCount((prev) => prev + beneficiaryOnlyCount);
        // }
      } else {
        setFilteredBeneAccountsCount(GlobalConfiguration.lengthCheckZero);
      }
      if (data1?.status === true) {
        const accounts = data1?.reimbursement_accounts || [];

        const reimbursementOnlyCount = accounts?.length;

        if (currentPage === GlobalConfiguration?.lengthCheckOne) {
          setReimbursementAccountsCount(reimbursementOnlyCount);
        } else {
          setReimbursementAccountsCount(
            (prev) => prev + reimbursementOnlyCount,
          );
        }
      } else {
        setReimbursementAccountsCount(GlobalConfiguration.lengthCheckZero);
      }
      // if (data2?.status === true) {
      //   const accounts = data2?.field_force_accounts || [];

      //   const activeCatArray = (categories || "")
      //     .split(",")
      //     .map((cat) => cat.trim().toLowerCase())
      //     .filter(Boolean);

      //   const fieldForceOnlyCount = accounts.filter((acc) => {
      //     const accCats = Array.isArray(acc?.category_ids)
      //       ? acc.category_ids
      //           .map((cat) => (cat?.category_name || "").trim().toLowerCase())
      //           .filter(Boolean)
      //       : [];

      //     const hasAllActive =
      //       activeCatArray.length > 0 &&
      //       activeCatArray.every((cat) => accCats.includes(cat));

      //     const backendFlag =
      //       String(acc?.all_category_assign || "")
      //         .trim()
      //         .toUpperCase() === "Y";

      //     return hasAllActive || backendFlag;
      //   }).length;

      //   if (currentPage >= GlobalConfiguration.lengthCheckOne) {
      //     setFieldForceAccountsCount(fieldForceOnlyCount);
      //   } else {
      //     setFieldForceAccountsCount((prev) => prev + fieldForceOnlyCount);
      //   }
      // }
      // else {
      //   setFieldForceAccountsCount(GlobalConfiguration.lengthCheckZero);
      // }
    } catch (error) {
      console.error("Beneficiary fetch failed", error);
      setFilteredBeneAccountsCount(GlobalConfiguration.lengthCheckZero);
      // setFieldForceAccountsCount(GlobalConfiguration.lengthCheckZero);
    } finally {
      setHasFetchedCount(true);
    }
  };

  useEffect(() => {
    if (
      categoriesData.filter((category) => category?.active === "Y") &&
      categoriesData.filter((category) => category?.active === "Y").length >
        GlobalConfiguration.lengthCheckZero
    ) {
      setHasFetchedCount(false);

      const categoryIds = categoriesData
        .filter((category) => category?.active === "Y")
        .map((data) => data?.id);

      const categoryNamesStr = categoryIds.join(",");

      fetchAccountData(categoryNamesStr, currentPage);
    }
  }, [categoriesData, currentPage]);

  const handleInfoPanel = (label) => {
    if (activeLabel === label) {
      closePanel();
    } else {
      setActiveLabel(label);
      setOpenMessagePanel(true);
    }
  };

  const closePanel = () => {
    setOpenMessagePanel(false);
    setTimeout(
      () => setActiveLabel(null),
      PaginationConfiguration.paginationBig,
    );
  };

  // Alert handler - same as MessagePanel
  const handleBeneAcctView = useCallback(() => {
    if (filteredBeneAccountsCount === GlobalConfiguration.lengthCheckZero) {
      return;
    }

    if (
      services?.includes("Admin") ||
      (services?.includes("BVAccount") &&
        services?.includes("PLogin") &&
        services?.includes("BUAccount"))
    ) {
      navigate("/home/unassign_multi_categories");
      closePanel();
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "Admin, BVAccount, PLogin, BUAccount",
        },
      });
    }
  }, [filteredBeneAccountsCount, services, navigate]);

  const handleReimbursementCat = useCallback(() => {
    if (reimbursementAccountsCount === GlobalConfiguration.lengthCheckZero) {
      return;
    }

    if (
      services?.includes("Admin") ||
      (services?.includes("RVAccount") &&
        services?.includes("PLogin") &&
        services?.includes("RUAccount"))
    ) {
      navigate("/home/unassign_reimbursement_categories");
      closePanel();
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "Admin, RVAccount, PLogin, RUAccount",
        },
      });
    }
  }, [reimbursementAccountsCount, services, navigate]);

  const handleFieldForceCat = useCallback(() => {
    if (fieldForceAccountsCount === GlobalConfiguration.lengthCheckZero) {
      return;
    }

    if (
      services?.includes("Admin") ||
      (services?.includes("FFVAccount") &&
        services?.includes("PLogin") &&
        services?.includes("FFUAccount"))
    ) {
      navigate("/home/unassign_field_force_categories");
      closePanel();
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "Admin, FFVAccount, PLogin, FFUAccount",
        },
      });
    }
  }, [fieldForceAccountsCount, services, navigate]);

  // Alert content logic - same as MessagePanel
  const alertContentRaw = useMemo(
    () => [
      {
        mainText: `Unsafe beneficiary accounts found - ${filteredBeneAccountsCount.toLocaleString?.() ?? "00"}`,
        subText:
          "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
        viewAllFunct: handleBeneAcctView,
        show: filteredBeneAccountsCount > GlobalConfiguration.lengthCheckZero,
      },
      // {
      //   mainText: `Unsafe reimbursement accounts found - ${reimbursementAccountsCount.toLocaleString?.() ?? "00"}`,
      //   subText:
      //     "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
      //   viewAllFunct: handleReimbursementCat,
      //   show: reimbursementAccountsCount > GlobalConfiguration.lengthCheckZero,
      // },
      // {
      //   mainText: `Unsafe field force accounts found - ${fieldForceAccountsCount.toLocaleString?.() ?? "00"}`,
      //   subText:
      //     "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
      //   viewAllFunct: handleFieldForceCat,
      //   show: fieldForceAccountsCount > GlobalConfiguration.lengthCheckZero,
      // },
    ],
    [
      filteredBeneAccountsCount,
      handleBeneAcctView,
      handleReimbursementCat,
      reimbursementAccountsCount,
      handleFieldForceCat,
      fieldForceAccountsCount,
    ],
  );

  const alertContent = useMemo(
    () => alertContentRaw.filter((item) => item.show),
    [alertContentRaw],
  );

  useEffect(() => {
    const actionableAlerts = alertContent.filter((item) => item.show);
    setAlertCount(actionableAlerts.length);
  }, [alertContent]);

  useEffect(() => {
    if (!ownerAccBalanceLoading) {
      setTimeout(() => {
        toast.dismiss();
        if (showSuccessToast) {
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
            dispatch(setshowsuccestoast());
          }, PaginationConfiguration.paginationMid);
        }
      }, errorcode.errorFailed);
    }
  }, [ownerAccBalanceLoading]);

  const nextSlide = () => {
    if (currentSlide < widgets.length - GlobalConfiguration.lengthCheckOne) {
      setCurrentSlide(currentSlide + GlobalConfiguration.lengthCheckOne);
    }
  };

  const prevSlide = () => {
    if (currentSlide > GlobalConfiguration.lengthCheckZero) {
      setCurrentSlide(currentSlide - GlobalConfiguration.lengthCheckOne);
    }
  };

  const AddStatistics = () => {
    if (!services?.includes("VStatistics")) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "VStatistics" },
      });
      return;
    }
    navigate("/settings/statistics");
  };

  const groupByMonth = (holidays) => {
    return holidays.reduce((acc, holiday) => {
      const date = new Date(holiday.date);
      const month = date.toLocaleString("default", { month: "long" });
      if (!acc[month]) {
        acc[month] = [];
      }
      acc[month].push(holiday);
      return acc;
    }, {});
  };

  const holidaysByMonth = groupByMonth(holidays);

  const employee = JSON.parse(sessionStorage.getItem("response"))?.employees;
  const canConciergeLogin = employee?.can_concierge_login === "Y";

  let pullTabIsSupressed =
    JSON.parse(sessionStorage.getItem("suppressPullTab")) ?? false;

  const [bannerDismissed, setBannerDismissed] = useState(() => {
    const stored = sessionStorage.getItem("bannerDismissed");
    return stored ? JSON.parse(stored) : false;
  });

  const subEntitySelected =
    sessionStorage.getItem("subEntitySelected") === "true";

  const showBanner =
    canConciergeLogin &&
    pullTabIsSupressed &&
    !bannerDismissed &&
    !subEntitySelected;

  const showHolidayModalBannerOffset =
    showBanner || isOutsideBankingHoursActive;

  const DataArray = [
    {
      headerName: "Unsafe beneficiary accounts found",
      subtext:
        "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
      btnText: "View all",
      count: filteredBeneAccountsCount.toLocaleString(),
      isDisabled:
        filteredBeneAccountsCount === GlobalConfiguration.lengthCheckZero
          ? true
          : false,
      handleFunction: () => {
        handleBeneAcctView();
      },
    },
    // {
    //   headerName: "Unsafe reimbursement accounts found",
    //   subtext:
    //     "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
    //   btnText: "View all",
    //   count: reimbursementAccountsCount.toLocaleString(),
    //   isDisabled:
    //     reimbursementAccountsCount === GlobalConfiguration.lengthCheckZero
    //       ? true
    //       : false,
    //   handleFunction: () => {
    //     handleReimbursementCat();
    //   },
    // },
    // {
    //   headerName: "Unsafe field force accounts found",
    //   subtext:
    //     "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
    //   btnText: "View all",
    //   count: fieldForceAccountsCount.toLocaleString(),
    //   isDisabled:
    //     fieldForceAccountsCount === GlobalConfiguration.lengthCheckZero
    //       ? true
    //       : false,
    //   handleFunction: () => {
    //     handleFieldForceCat();
    //   },
    // },
  ];

  const chipsArray = [
    {
      text: "Beneficiary Transactions",
      imgUrl: ICONS?.BENEFICIARY_TRANSACTION_BLUE_CIRCLE,
      disabled: !hasCreateService,
      onClick: () => {
        if (!hasCreateService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "CBeneficiaryTxn" },
          });
        } else {
          navigate(
            "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
            {
              state: navDetails,
            },
          );
        }
      },
    },
    {
      text: "Internal Transactions",
      imgUrl: ICONS?.INTERNAL_TRANSACTION_BLUE_CIRCLE,
      disabled: !hasCreateInternalService,
      onClick: () => {
        if (!hasCreateInternalService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "CInternalTxn" },
          });
        } else {
          sessionStorage.removeItem("recreate_int_txn_id");
          navigate(
            "/internal_transaction_dashboard/create_internal_transaction",
            {
              state: navDetails,
            },
          );
        }
      },
    },
  ];

  const currentMonth = new Date().toLocaleString("default", {
    month: "long",
  });

  const [openMonth, setOpenMonth] = useState(currentMonth);

  const toggleMonth = (month) => {
    setOpenMonth((prev) => (prev === month ? null : month));
  };

  const getHolidayLabel = ({ date, occasion }) => {
    const d = new Date(date);
    const day = d.toLocaleDateString("en-US", { weekday: "long" });

    const cleanOccasion = occasion?.trim();
    const isWeekend = day === "Saturday" || day === "Sunday";

    if (isWeekend) {
      return cleanOccasion &&
        cleanOccasion !== "Saturday" &&
        cleanOccasion !== "Sunday"
        ? cleanOccasion
        : "Weekend";
    }

    return cleanOccasion;
  };

  const calendarScrollRef = useRef(null);

  useEffect(() => {
    if (isCalendarOpen && calendarScrollRef.current) {
      calendarScrollRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
  }, [isCalendarOpen]);

  const [isCalendarOpenScroll, setIsCalendarOpenScroll] = useState(false);

  const pageScrollRef = useRef(null);
  useEffect(() => {
    if (isCalendarOpenScroll && pageScrollRef.current) {
      pageScrollRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
  }, [isCalendarOpenScroll]);

  /* ---------------- DYNAMIC SORTED ARRAYS ---------------- */

  const sortedApproveTxnItems = useMemo(() => {
    return [
      {
        img: ICONS?.BENEFICIARY_TRANSACTION_BLUE_CIRCLE,
        titleBase: "Beneficiary",
        desc: (
          <>
            Approve beneficiary <br />
            transactions
          </>
        ),
        service: "ABeneficiaryTxn",
        navigateTo:
          "/beneficiary_transaction_dashboard/beneficiary_transaction_single_approval",
        computedCount: !services?.includes("ABeneficiaryTxn")
          ? GlobalConfiguration.lengthCheckNegativeOne
          : beneficiaryTxnCount || GlobalConfiguration.lengthCheckZero,
        baseOrder: GlobalConfiguration.lengthCheckOne,
      },
      {
        img: ICONS?.INTERNAL_TRANSACTION_BLUE_CIRCLE,
        titleBase: "Internal",
        desc: (
          <>
            Approve internal <br />
            transactions
          </>
        ),
        service: "AInternalTxn",
        navigateTo:
          "/internal_transaction_dashboard/internal_transaction_single_approval",
        computedCount: !services?.includes("AInternalTxn")
          ? -1
          : internalTxnCount || GlobalConfiguration.lengthCheckZero,
        baseOrder: GlobalConfiguration.lengthCheckTwo,
      },
      // {
      //   img: ICONS?.REIMBURSEMENT_TRANSACTION_BLUE_CIRCLE,
      //   titleBase: "Reimbursement",
      //   desc: "View more options related to reimbursement",
      //   service: ["AReimbursementTxn", "AReimbursementRequest"],
      //   navigateToSlider: "approve_reimbursement",
      //   computedCount: !(
      //     services?.includes("AReimbursementTxn") ||
      //     services?.includes("AReimbursementRequest")
      //   )
      //     ? GlobalConfiguration.lengthCheckNegativeOne
      //     : (reimbursementTxnCount || GlobalConfiguration.lengthCheckZero) +
      //       (reimbursementRequestCount || GlobalConfiguration.lengthCheckZero),
      //   baseOrder: GlobalConfiguration.lengthCheckThree,
      // },
      // {
      //   img: ICONS?.FIELD_FORCE_TRANSACTION_BLUE_CIRCLE,
      //   titleBase: "Field force",
      //   desc: "View more options related to field force",
      //   service: ["AFieldForceTxn", "AFieldForceRequest"],
      //   navigateToSlider: "approve_field_force",
      //   computedCount: !(
      //     services?.includes("AFieldForceTxn") ||
      //     services?.includes("AFieldForceRequest")
      //   )
      //     ? GlobalConfiguration.lengthCheckNegativeOne
      //     : (fieldForceTnxCount || GlobalConfiguration.lengthCheckZero) +
      //       (fieldForceRequestTnxCount || GlobalConfiguration.lengthCheckZero),
      //   baseOrder: GlobalConfiguration.lengthCheckFour,
      // },
      // {
      //   img: ICONS.PRIVATE_TRANSACTION_BLUE_CIRCLE,
      //   titleBase: "Private",
      //   desc: (
      //   <>
      //     Approve private <br />
      //     transactions
      //   </>
      // ),
      //   service: "APrivateTransaction",
      //   navigateTo:
      //     "/private_transaction_dashboard/private_transaction_approval",
      //   computedCount: !services?.includes("APrivateTransaction")
      //     ? GlobalConfiguration.lengthCheckNegativeOne
      //     : privateTnxCount || GlobalConfiguration.lengthCheckZero,
      //   baseOrder: GlobalConfiguration.lengthCheckFive,
      // },
    ]
      .sort((a, b) => {
        if (b.computedCount !== a.computedCount) {
          return b.computedCount - a.computedCount;
        }
        return a.baseOrder - b.baseOrder;
      })
      .map((item) => ({
        img: item.img,
        title: `${item.titleBase} - ${item.computedCount === -1 ? "N/A" : item?.computedCount?.toString()?.padStart(2, "0")}`,
        desc: item.desc,
        service: item.service,
        navigateTo: item.navigateTo,
        navigateToSlider: item.navigateToSlider,
      }));
  }, [services, beneficiaryTxnCount, internalTxnCount]);

  const sortedApproveAccItems = useMemo(() => {
    return [
      {
        img: ICONS?.BENEFICIARY_ACCOUNT_WITH_BLUE_CIRCLE,
        titleBase: "Beneficiary",
        desc: "Approve beneficiary accounts",
        requiredService: "BAAccount",
        path: "/beneficiary_account_dashboard/beneficiary_account_approval",
        loading: getAllBeneficiaryAccountsLoading,
        computedCount: !services?.includes("BAAccount")
          ? GlobalConfiguration.lengthCheckNegativeOne
          : beneficiaryAccountCount || GlobalConfiguration.lengthCheckZero,
        baseOrder: GlobalConfiguration.lengthCheckOne,
      },
      {
        img: ICONS?.INTERNAL_ACCOUNT_WITH_BLUE_CIRCLE,
        titleBase: "Internal",
        desc: "Approve internal accounts",
        requiredService: "IAAccount",
        path: "/internal_account_dashboard/internal_account_approval",
        loading: getAllInternalAccountLoading,
        computedCount: !services?.includes("IAAccount")
          ? GlobalConfiguration.lengthCheckNegativeOne
          : internalAccountCount || GlobalConfiguration.lengthCheckZero,
        baseOrder: GlobalConfiguration.lengthCheckTwo,
      },
      // {
      //   img: ICONS.REIMBURSEMENT_ACCOUNTS_WITH_BLUE_CIRCLE,
      //   titleBase: "Reimbursement",
      //   desc: "Approve reimbursement accounts",
      //   requiredService: "RAAccount",
      //   path: "/reimbursement_account_dashboard/reimbursement_account_approval",
      //   loading: ReimburseViewAllHomeDashboardLoading,
      //   computedCount: !services?.includes("RAAccount")
      //     ? GlobalConfiguration.lengthCheckNegativeOne
      //     : reimbursementAccCount || GlobalConfiguration.lengthCheckZero,
      //   baseOrder: GlobalConfiguration.lengthCheckThree,
      // },
      // {
      //   img: ICONS?.FIELD_FORCE_ACCOUNTS_WITH_BLUE_CIRCLE,
      //   titleBase: "Field force",
      //   desc: "Approve field force accounts",
      //   requiredService: "FFAAccount",
      //   path: "/field_force_account_dashboard/field_force_account_approval",
      //   loading: allfieldForceAccountLoading,
      //   computedCount: !services?.includes("FFAAccount")
      //     ? GlobalConfiguration.lengthCheckNegativeOne
      //     : fieldForceAccountCount || GlobalConfiguration.lengthCheckZero,
      //   baseOrder: GlobalConfiguration.lengthCheckFour,
      // },
      {
        img: ICONS.REMITTER_ACCOUNT_WITH_BLUE_CIRCLE,
        titleBase: "Remitter",
        desc: "Approve remitter accounts",
        requiredService: "REAAccount",
        path: "/remitter_account_dashboard/remitter_account_approval",
        loading: remitterAccountViewAllLoading,
        computedCount: !services?.includes("REAAccount")
          ? GlobalConfiguration.lengthCheckNegativeOne
          : remitterAccountCount || GlobalConfiguration.lengthCheckZero,
        baseOrder: GlobalConfiguration.lengthCheckFive,
      },
    ]
      .sort((a, b) => {
        if (b.computedCount !== a.computedCount) {
          return b.computedCount - a.computedCount;
        }
        return a.baseOrder - b.baseOrder;
      })
      .map((item) => ({
        img: item.img,
        title: `${item.titleBase} - ${item.computedCount === -1 ? "N/A" : item.computedCount.toString().padStart(2, "0")}`,
        desc: item.desc,
        requiredService: item.requiredService,
        path: item.path,
        loading: item.loading,
      }));
  }, [
    services,
    beneficiaryAccountCount,
    internalAccountCount,
    // reimbursementAccCount,
    fieldForceAccountCount,
    remitterAccountCount,
    getAllBeneficiaryAccountsLoading,
    getAllInternalAccountLoading,
    // ReimburseViewAllHomeDashboardLoading,
    // allfieldForceAccountLoading,
    remitterAccountViewAllLoading,
  ]);

  const transactionSlidingArray = useMemo(
    () => [
      {
        key: "pay",
        items: [
          {
            img: ICONS?.BENEFICIARY_TRANSACTION_BLUE_CIRCLE,
            title: "Beneficiary",
            desc: (
              <>
                Create a beneficiary <br /> transaction
              </>
            ),
            service: "CBeneficiaryTxn",
            navigateTo:
              "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
          },
          {
            img: ICONS?.INTERNAL_TRANSACTION_BLUE_CIRCLE,
            title: "Internal",
            desc: (
              <>
                Create an internal <br /> transaction
              </>
            ),
            service: "CInternalTxn",
            navigateTo:
              "/internal_transaction_dashboard/create_internal_transaction",
          },
          // {
          //   img: ICONS?.REIMBURSEMENT_TRANSACTION_BLUE_CIRCLE,
          //   title: "Reimbursement",
          //   desc: (
          //     <>
          //       Create a reimbursement <br /> transaction
          //     </>
          //   ),
          //   service: "CReimbursementTxn",
          //   navigateTo:
          //     "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
          // },
          // {
          //   img: ICONS?.PRIVATE_TRANSACTION_BLUE_CIRCLE,
          //   title: "Private",
          //   desc: (
          //     <>
          //       Create a private <br /> transaction
          //     </>
          //   ),
          //   service: "CPrivateTransaction",
          //   navigateTo:
          //     "/private_transaction_dashboard/create_private_transaction",
          // },
        ],
      },
      {
        key: "approve",
        items: sortedApproveTxnItems,
      },
      // {
      //   key: "approve_field_force",
      //   items: [
      //     {
      //       img: ICONS?.FIELD_FORCE_TRANSACTION_BLUE_CIRCLE,
      //       title: `Field force transactions - ${
      //         !services?.includes("AFieldForceTxn")
      //           ? "N/A"
      //           : (fieldForceTnxCount?.toString().padStart(2, "0") ?? "00")
      //       }`,
      //       desc: (
      //         <>
      //           Approve field force <br className="hidden lg:inline" />
      //           transactions
      //         </>
      //       ),
      //       service: "AFieldForceTxn",
      //       navigateTo:
      //         "/field_force_transaction_dashboard/field_force_transaction_single_approval",
      //     },
      //     {
      //       img: ICONS.FIELD_FORCE_TRANSACTION_BLUE_CIRCLE,
      //       title: `Field force requests - ${
      //         !services?.includes("AFieldForceRequest")
      //           ? "N/A"
      //           : (fieldForceRequestTnxCount?.toString().padStart(2, "0") ??
      //             "00")
      //       }`,
      //       desc: (
      //         <>
      //           Approve field force <br className="hidden lg:inline" />
      //           requests
      //         </>
      //       ),
      //       service: "AFieldForceRequest",
      //       navigateTo:
      //         "/field_force_transaction_dashboard/field_force_request_single_approval",
      //     },
      //   ],
      // },
      // {
      //   key: "approve_reimbursement",
      //   items: [
      //     {
      //       img: ICONS?.REIMBURSEMENT_TRANSACTION_BLUE_CIRCLE,
      //       title: `Reimbursement transactions - ${
      //         !services?.includes("AReimbursementTxn")
      //           ? "N/A"
      //           : (reimbursementTxnCount?.toString().padStart(2, "0") ?? "00")
      //       }`,
      //       desc: (
      //         <>
      //           Approve reimbursement <br className="hidden lg:inline" />
      //           transactions
      //         </>
      //       ),
      //       service: "AReimbursementTxn",
      //       navigateTo:
      //         "/reimbursement_transaction_dashboard/reimbursement_transaction_single_approval",
      //     },
      //     {
      //       img: ICONS?.REIMBURSEMENT_TRANSACTION_BLUE_CIRCLE,
      //       title: `Reimbursement requests - ${
      //         !services?.includes("AReimbursementRequest")
      //           ? "N/A"
      //           : (reimbursementRequestCount?.toString().padStart(2, "0") ??
      //             "00")
      //       }`,
      //       desc: (
      //         <>
      //           Approve reimbursement <br className="hidden lg:inline" />{" "}
      //           requests
      //         </>
      //       ),
      //       service: "AReimbursementRequest",
      //       navigateTo:
      //         "/reimbursement_transaction_dashboard/reimbursement_request_single_approval",
      //     },
      //   ],
      // },
      {
        key: "receive",
        items: [],
      },
    ],
    [sortedApproveTxnItems, services],
  );

  const accountSlidingArray = useMemo(
    () => [
      {
        key: "create",
        items: [
          {
            img: ICONS?.BENEFICIARY_ACCOUNT_WITH_BLUE_CIRCLE,
            title: `Beneficiary`,
            desc: `Create a beneficiary account`,
            requiredService: "BUAccount",
            path: "/beneficiary_account_dashboard/create_beneficiary_account",
          },

          // {
          //   img: ICONS.REIMBURSEMENT_ACCOUNTS_WITH_BLUE_CIRCLE,
          //   title: `Reimbursement`,
          //   desc: `Create a reimbursement account`,
          //   requiredService: "RUAccount",
          //   path: "/reimbursement_account_dashboard/create_reimbursement_account",
          // },

          // {
          //   img: ICONS.FIELD_FORCE_ACCOUNTS_WITH_BLUE_CIRCLE,
          //   title: `Field force`,
          //   desc: `Create a field force account`,
          //   requiredService: "FFUAccount",
          //   path: "/field_force_account_dashboard/create_field_force_account",
          // },

          {
            img: ICONS.REMITTER_ACCOUNT_WITH_BLUE_CIRCLE,
            title: `Remitter`,
            desc: `Create a remitter account`,
            requiredService: "REUAccount",
            path: "/remitter_account_dashboard/create_remitter_account",
          },
        ],
      },
      {
        key: "approve",
        items: sortedApproveAccItems,
      },
    ],
    [sortedApproveAccItems],
  );

  /* ---------------- FORMATTING & SLIDES ---------------- */
  const formattedDate = useMemo(() => {
    if (holidays.length === 0) return null;

    const d = new Date(holidays[0].date);
    if (isNaN(d)) return null;

    const day = d.toLocaleString("en-GB", { day: "numeric" });
    const month = d.toLocaleString("en-GB", { month: "short" });
    const year = d.getFullYear();

    return `${day} ${month}, ${year}`;
  }, [holidays]);

  const TXN_MAX_PER_SLIDE = 3;

  // Level 1 extraction (Pay/Receive/Approve)
  const level1Items = useMemo(
    () =>
      transactionSlidingArray.find((c) => c.key === txnLevel1Key)?.items ?? [],
    [txnLevel1Key, transactionSlidingArray],
  );

  const level1Slides = useMemo(() => {
    const result = [];
    for (let i = 0; i < level1Items.length; i += TXN_MAX_PER_SLIDE) {
      result.push(level1Items.slice(i, i + TXN_MAX_PER_SLIDE));
    }
    return result;
  }, [level1Items]);

  // Level 2 extraction (Sub-options for Approval)
  const level2Items = useMemo(
    () =>
      transactionSlidingArray.find((c) => c.key === txnLevel2Key)?.items ?? [],
    [txnLevel2Key, transactionSlidingArray],
  );

  const level2Slides = useMemo(() => {
    const result = [];
    for (let i = 0; i < level2Items.length; i += TXN_MAX_PER_SLIDE) {
      result.push(level2Items.slice(i, i + TXN_MAX_PER_SLIDE));
    }
    return result;
  }, [level2Items]);

  /* --------------- INITIALS HELPER ----------------- */
  const getInitials = () => {
    const fName =
      userData?.employees?.first_name || userData?.employees?.firstName || "";
    const lName =
      userData?.employees?.last_name || userData?.employees?.lastName || "";

    if (fName || lName) {
      return `${fName.charAt(0)}${lName.charAt(0)}`.toUpperCase();
    }
    return "NA";
  };

  /* ---------------- ACCOUNTS ---------------- */

  const accKey = openAccountSlider;

  const accItems =
    accountSlidingArray.find((c) => c.key === accKey)?.items ?? [];

  const ACC_MAX_PER_SLIDE = 2;

  const accSlides = useMemo(() => {
    const result = [];
    for (let i = 0; i < accItems.length; i += ACC_MAX_PER_SLIDE) {
      result.push(accItems.slice(i, i + ACC_MAX_PER_SLIDE));
    }
    return result;
  }, [accItems]);

  const [accActiveSlide, setAccActiveSlide] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  useEffect(() => {
    setAccActiveSlide(GlobalConfiguration.lengthCheckZero);
  }, [openAccountSlider]);

  function handleOpenBanner() {
    setShowOutsideBankingBanner(true);
  }

  return (
    <div
      ref={pageScrollRef}
      style={{ height: "var(--full-height)" }}
      className={`bg-primary-bg w-width-full pt-padding-xl px-padding-sm lg:px-padding-lg pb-padding-md  ${
        isCalendarOpen ? "ScrollingBehavior" : "overflow-y-auto"
      }`}
    >
      {isReminderPopupOpen && (
        <div
          className={`fixed top-0 left-0 w-screen h-screen ${showModal ? "" : "bg-PopUp-BackDrop"}  bg-opacity-dark-opacity z-z-index-modal`}
        >
          <SmallReminderPopup
            headerTitle={"Reminders"}
            subtext={"The following reminders require your attention."}
            closeIconBgColor={"var(--primary-nav)"}
            closeCallback={() => setIsReminderPopupOpen(false)}
            remindersListData={reminderTxnViewData?.reminders}
            chipsArray={chipsArray}
            hasModService={hasModService}
            hasCreateService={hasCreateService}
            hasCreateInternalService={hasCreateInternalService}
            viewAllReminderService={viewAllReminderService}
            setSelectedTxnData={setSelectedTxnData}
            buttonText={"Create transaction"}
            bottomButtonText={"View all"}
            primaryBtnBgColor="var(--primary-act)"
            showModal={showModal}
            setShowModal={setShowModal}
          />
        </div>
      )}

      {/* Pls do not uncomment as it will be future implemented */}
      {/* {isTermsConditionPopupOpen && (
        <div className="fixed top-0 left-0 w-screen h-screen bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-modal">
          <CommonTermsAndConditionsPopup
            setTermsConditionsPopupOpen={setTermsConditionsPopupOpen}
            onDisagreeLogout={() => {
              navigate("/login");
              dispatch(xpentraLogout());
              dispatch(setMultipleEntity());
              dispatch(setShowReloginModalFalse());
              dispatch(logout());
              dispatch(xpentraLogoutSliceReset());
              sessionStorage.clear();
            }}
            entityName={
              JSON.parse(sessionStorage.getItem("response"))?.entity
                ?.entity_name
            }
            userName={`${JSON.parse(sessionStorage.getItem("response"))?.employees?.first_name || ""} ${JSON.parse(sessionStorage.getItem("response"))?.employees?.last_name || ""}`.trim()}
          />
        </div>
      )} */}

      {isAnnouncementPopupOpen && (
        <div className="fixed top-0 left-0 w-screen h-screen bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-modal">
          <SmallAnnocementsPopup
            headerTitle={"Updates"}
            subtext={"Important update: Please review the details below."}
            closeIconBgColor={"var(--primary-nav)"}
            closeCallback={() => setIsAnnouncementPopupOpen(false)}
            announcementData={announcementData}
          />
        </div>
      )}

      {openMessagePanel &&
        activeLabel?.toLowerCase() === "alert" &&
        alertCount >= GlobalConfiguration.lengthCheckOne && (
          <div className="fixed top-0 left-0 w-screen h-screen bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-modal">
            <SmallAlertPopup
              headerTitle="Alert"
              subtext="The following alerts require your attention."
              closehandleFunction={closePanel}
              isDataArray={DataArray}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-act)"
              disabledBgColor="var(--primary-act)"
              btnOutLineColor=""
              disabledTextColor=""
              isLoading={false}
              btnhoverOption="white"
              btnFullWidthRequired={false}
              btnInActiveVariantNeeded={false}
              btnIsLoaderNeeded={false}
              buttonRef=""
            />
          </div>
        )}

      {showOutsideBankingBanner && (
        <div
          className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => setShowOutsideBankingBanner(false)}
        >
          <SmallPopupWithBulletPoints
            headerTitle={"Why transaction cannot be processed?"}
            headIconColor="var(--text-primary)"
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowOutsideBankingBanner(false)}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderFontWeight="semibold"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${outsideBankingHoursLabel} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
          />
        </div>
      )}

      <div className="Qsmd:hidden w-width-full fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center justify-between z-z-index-fixed-ui rounded-b-border-radius-sm h-[var(--home-nav-mobile-height)] pl-mobile-padding-l pr-mobile-padding-l border-b border-primary-bg shadow-sm">
        <div className="flex items-center">
          <img
            src={ICONS?.XPENTRA_BLUE}
            alt="Xpentra Logo"
            className="w-[6.188rem]"
          />
        </div>
        <div className="flex gap-gap-sm">
          <div
            className="text-xs bg-text-secondary text-primary-bg h-[var(--profile-initials-w-h)] w-[var(--profile-initials-w-h)] flex items-center justify-center z-z-index-max rounded-full font-semibold cursor-pointer"
            onClick={() => navigate("/home/profile_quick_menu")}
          >
            {getInitials()}
          </div>
        </div>
      </div>

      <div className="flex flex-col Qsmd:mt-margin-xl mt-margin-lg  lg:mx-auto pb-padding-xl lg:pb-padding-base mb-margin-xl lg:mb-margin-base max-w-tab-width-normal w-width-full  gap-gap-md">
        {isOutsideBankingHoursActive && (
          <div className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content">
            <CommonAlertCard
              title={"Functioning outside banking hours"}
              texts={
                <>
                  Transactions will be processed automatically during the next
                  bank working day.{" "}
                  <span
                    className="underline cursor-pointer font-semibold"
                    onClick={() => handleOpenBanner()}
                  >
                    Learn more
                  </span>
                </>
              }
            />
          </div>
        )}

        <MultiEntityBanner
          sessionStatus={canConciergeLogin}
          showBanner={showBanner}
          setShowBanner={() => setBannerDismissed(true)}
        />

        <div className="flex Qsmd:flex-row flex-col gap-gap-md">
          <div className="w-width-full Qsmd:w-width-lg flex flex-col gap-gap-md lg:max-w-[var(--dashboard-left-card-width)]">
            {/* --- ACTION ICONS (ALERT, REMINDER, NOTIFICATIONS) --- 
                Now placed perfectly above the Transaction slider! 
            */}
            <div className="w-width-full bg-primary-nav flex rounded-border-radius-sm items-center z-z-index-content Qsmd:px-padding-base Qmd:pl-padding-md h-auto Qsmd:py-0 shadow-sm">
              <div className="flex flex-1 flex-shrink-0 justify-between Qsmd:justify-end items-center w-width-full lg:max-w-[var(--dashboard-left-card-width)]">
                {[
                  {
                    label: "Alert",
                    count: alertCount,
                    requiredServices: [
                      "BUAccount",
                      "RUAccount",
                      "Admin",
                      "MimicEntity",
                      "BVAccount",
                      "RVAccount",
                    ],
                    icon: ICONS?.ALERT_WHITE,
                    activeIcon: ICONS?.ALERT,
                    activeColor: "var(--alert-red)",
                    inactiveColor: "var(--abandoned)",
                  },
                  {
                    label: "Reminder",
                    count: reminderTxnViewData?.total_count,
                    icon: ICONS?.REMINDERS_WHITE,
                    activeColor: "var(--awaiting)",
                    inactiveColor: "var(--abandoned)",
                    requiredServices: ["Admin", "VReminder", "AReminder"],
                  },
                  // {
                  //   label: "Notification",
                  //   count: 0,
                  //   icon: ICONS?.NOTIFICATION_GREY,
                  //   bgColor: "var(---positive-act)",
                  //   activeColor: "var(--positive-act)",
                  //   inactiveColor: "var(--abandoned)",
                  //   requiredServices: [
                  //     "Admin",
                  //     "Notify",
                  //     "CChannel",
                  //     "VChannel",
                  //   ],
                  // },
                ].map(
                  (
                    {
                      icon,
                      activeIcon,
                      label,
                      count,
                      requiredServices,
                      activeColor,
                      inactiveColor,
                    },
                    index,
                    arr,
                  ) => {
                    const servicesAvailable = requiredServices
                      ? Array.isArray(services) &&
                        requiredServices.some((service) =>
                          services?.includes(service),
                        )
                      : true;
                    const isDisabled =
                      (label === "Alert" && !servicesAvailable) ||
                      (label === "Reminder" && !servicesAvailable) ||
                      !servicesAvailable;

                    const handleClick = () => {
                      const hasServices = requiredServices
                        ? Array.isArray(services) &&
                          requiredServices.some((service) =>
                            services.includes(service),
                          )
                        : true;

                      if (
                        (label === "Reminder" || label === "Notification") &&
                        !hasServices
                      ) {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: requiredServices },
                        });
                        return;
                      }

                      if (label === "Reminder") {
                        setIsReminderPopupOpen(true);
                        return;
                      }

                      if (
                        label === "Alert" &&
                        count === GlobalConfiguration.lengthCheckZero
                      ) {
                        return;
                      }
                      handleInfoPanel(label);
                    };

                    const isActive =
                      label === "Notification"
                        ? count > GlobalConfiguration.lengthCheckZero
                        : count > GlobalConfiguration.lengthCheckZero ||
                          (label === "Reminder" && !isDisabled) ||
                          (label === "Alert" && !isDisabled);

                    const iconUrl =
                      label === "Alert" && isActive && activeIcon
                        ? activeIcon
                        : icon;

                    const iconColor = isActive ? activeColor : inactiveColor;

                    return (
                      <React.Fragment key={label}>
                        <div
                          style={{
                            opacity:
                              isDisabled ||
                              (label !== "Reminder" &&
                                count === GlobalConfiguration.lengthCheckZero)
                                ? "var(--light-opacity)"
                                : "var(--base-opacity)",
                          }}
                          className={`flex-1 items-center p-padding-sm relative`}
                          onClick={handleClick}
                        >
                          <div
                            className={`flex justify-center Qsmd:justify-between items-center px-padding-sm py-padding-sm group hover:bg-none rounded-border-radius-md relative gap-gap-sm z-z-index-base ${
                              isDisabled ||
                              (alertCount ===
                                GlobalConfiguration.lengthCheckZero &&
                                label === "Alert")
                                ? "cursor-not-allowed"
                                : "cursor-pointer global-hover-white"
                            }`}
                          >
                            <div
                              className={`text-font-xs font-semibold flex items-center gap-gap-sm rounded-md `}
                            >
                              <div className="w-auto h-auto bg-transparent flex justify-center items-center relative">
                                {label === "Alert" ? (
                                  <SVGComponent
                                    url={iconUrl}
                                    height="var(--icon-md)"
                                    width="var(--icon-md)"
                                  />
                                ) : (
                                  <SVGComponent
                                    url={iconUrl}
                                    height="var(--icon-md)"
                                    width="var(--icon-md)"
                                    color={iconColor}
                                  />
                                )}
                              </div>

                              <span className="hidden Qsmd:flex text-text-primary">
                                {`${label}s`}
                              </span>
                            </div>

                            <div className="hidden Qsmd:flex relative items-center justify-center w-icon-xs h-icon-xs">
                              <span
                                className={`w-icon-xs h-icon-xs rounded-full inline-block ${
                                  !isDisabled ? "group-hover:hidden" : ""
                                }`}
                              ></span>
                              {!isDisabled && (
                                <span className="hidden group-hover:flex items-center justify-center absolute">
                                  <SVGComponent
                                    url={ICONS.ARROW_RIGHT_WHITE}
                                    height="var(--icon-sm)"
                                    width="var(--icon-sm)"
                                    color="var(--text-primary)"
                                  />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        {index !==
                          arr.length - GlobalConfiguration.lengthCheckOne && (
                          <div className="border-r-border border-primary-bg relative top-top-half h-6 max-h-[var(--category-icon-height)]"></div>
                        )}
                      </React.Fragment>
                    );
                  },
                )}
              </div>
            </div>

            <div className="w-width-full rounded-border-radius-md relative overflow-hidden">
              <div className="flex bg-primary-card rounded-t-border-radius-md ">
                <div
                  className={`relative py-padding-sm ${
                    txnActiveLevel > GlobalConfiguration.lengthCheckZero
                      ? "global-hover-white z-z-index-base cursor-pointer"
                      : ""
                  }`}
                  onClick={() => {
                    if (txnActiveLevel === GlobalConfiguration.lengthCheckTwo) {
                      setTxnActiveLevel(GlobalConfiguration.lengthCheckOne);
                      setLevel2ActiveSlide(GlobalConfiguration.lengthCheckZero);
                    } else if (
                      txnActiveLevel === GlobalConfiguration.lengthCheckOne
                    ) {
                      setTxnActiveLevel(GlobalConfiguration.lengthCheckZero);
                      setLevel1ActiveSlide(GlobalConfiguration.lengthCheckZero);
                    }
                  }}
                >
                  <div
                    className={`relative h-height-full border-primary-bg border-r-border top-top-base left-left-base flex items-center transition-all duration-animation-medium ${
                      txnActiveLevel > GlobalConfiguration.lengthCheckZero
                        ? "w-home-dashboard-back-arrow-width-slider"
                        : "w-width-base border-primary-card"
                    }`}
                  >
                    <div className="ml-margin-md">
                      <SVGComponent
                        url={ICONS?.ARROW_LEFT_WHITE}
                        color="var(--text-primary)"
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`w-full flex justify-between items-center px-padding-sm pl-padding-md py-padding-sm lg:py-padding-base my-margin-base lg:my-margin-sm transition-all duration-animation-medium ${
                    txnActiveLevel > GlobalConfiguration.lengthCheckZero
                      ? "rounded-tr-border-radius-md"
                      : "border-primary-bg"
                  }`}
                >
                  <div className="flex items-center gap-gap-sm">
                    <img
                      src={ICONS?.TRANSACTION_WHITE}
                      alt="transcation header"
                      className="w-icon-sm h-icon-sm"
                    />
                    <span className="text-font-sm font-semibold text-text-primary ">
                      {txnActiveLevel === GlobalConfiguration.lengthCheckZero
                        ? "Transactions and Requests"
                        : txnActiveLevel === GlobalConfiguration.lengthCheckOne
                          ? txnLevel1Key === "pay"
                            ? "Pay"
                            : txnLevel1Key === "receive"
                              ? "Receive"
                              : "Approve"
                          : "Transactions and Requests"}
                    </span>
                  </div>
                  <div
                    className={`flex gap-gap-sm mr-margin-sm transition-all duration-animation-medium ${
                      txnActiveLevel > GlobalConfiguration.lengthCheckZero &&
                      (txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                        ? level2Slides.length
                        : level1Slides.length) >
                        GlobalConfiguration.lengthCheckOne
                        ? "opacity-base-opacity"
                        : "opacity-opacity-none cursor-default"
                    }`}
                  >
                    <div
                      onClick={() => {
                        const currentActiveSlide =
                          txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                            ? level2ActiveSlide
                            : level1ActiveSlide;
                        if (
                          currentActiveSlide ===
                          GlobalConfiguration.lengthCheckZero
                        )
                          return;

                        if (
                          txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                        ) {
                          setLevel2ActiveSlide(
                            (p) => p - GlobalConfiguration.lengthCheckOne,
                          );
                        } else {
                          setLevel1ActiveSlide(
                            (p) => p - GlobalConfiguration.lengthCheckOne,
                          );
                        }
                      }}
                      className={`${
                        (txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                          ? level2ActiveSlide
                          : level1ActiveSlide) ===
                        GlobalConfiguration.lengthCheckZero
                          ? "opacity-light-opacity cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <SVGComponent
                        url={ICONS?.ARROW_LEFT_WHITE_CIRCLE}
                        height="var(--icon-sm)"
                        width="var(--icon-sm)"
                      />
                    </div>

                    <div
                      onClick={() => {
                        const currentActiveSlide =
                          txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                            ? level2ActiveSlide
                            : level1ActiveSlide;
                        const currentSlidesLength =
                          txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                            ? level2Slides.length
                            : level1Slides.length;

                        if (
                          currentActiveSlide ===
                          currentSlidesLength -
                            GlobalConfiguration.lengthCheckOne
                        )
                          return;

                        if (
                          txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                        ) {
                          setLevel2ActiveSlide(
                            (p) => p + GlobalConfiguration.lengthCheckOne,
                          );
                        } else {
                          setLevel1ActiveSlide(
                            (p) => p + GlobalConfiguration.lengthCheckOne,
                          );
                        }
                      }}
                      className={`${
                        (txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                          ? level2ActiveSlide
                          : level1ActiveSlide) ===
                        (txnActiveLevel === GlobalConfiguration.lengthCheckTwo
                          ? level2Slides.length
                          : level1Slides.length) -
                          GlobalConfiguration.lengthCheckOne
                          ? "opacity-light-opacity cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <SVGComponent
                        url={ICONS?.ARROW_RIGHT_WHITE_CIRCLE}
                        height="var(--icon-sm)"
                        width="var(--icon-sm)"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative bg-primary-nav w-width-full h-height-full overflow-hidden">
                <div
                  className={`w-width-triple flex transition-transform duration-animation-medium ease-in-out`}
                  style={{
                    transform: `translateX(calc(-${txnActiveLevel} * var(--home-txn-slider-slide-step)))`,
                  }}
                >
                  {/* PANE 0: Main options */}
                  <div className="w-1/3 relative flex-shrink-0 transition-transform duration-animation-medium">
                    <div className="grid Qsmd:grid-cols-3 grid-cols-1 w-full h-full">
                      {[
                        {
                          img: ICONS?.PAY_WITH_BLUE_CIRCLE,
                          title: "Pay",
                          desc: "Create an outgoing transaction",
                          type: "pay",
                          txnRequiredServices: [
                            "CBeneficiaryTxn",
                            "CInternalTxn",
                          ],
                          isDisabled: false,
                        },
                        {
                          img: ICONS?.RECIEVE_WITH_BLUE_CIRCLE,
                          title: "Receive",
                          desc: "Create an incoming request",
                          type: "receive",
                          // Remove this line when u dont want toast to show
                          comingSoon: true,
                          // txnRequiredServices: [
                          //   "CReimbursementTxn",
                          //   "CFieldForceTxn",
                          // ],
                          // isDisabled: true,
                        },
                        {
                          img: ICONS?.APPROVE_WITH_BLUE_CIRCLE,
                          title: (
                            <>
                              Approve -&nbsp;
                              {beneficiaryTransactionsViewAllLoading ||
                              internalTransactionsViewAllLoading ||
                              // reimbursementTxnViewAllLoading ||
                              // fieldForceRequestApprovalLoading ||
                              // reimbursementRequestApprovalLoading ||
                              // fieldForceTxnViewAllLoading ||
                              // allPrivateTransactionsLoading ||
                              // taxTransactionViewAllLoading ||
                              txnCountLoading ? (
                                <img
                                  src={ICONS?.LOADER_GIF}
                                  alt="Loading..."
                                  className="h-icon-sm inline-block"
                                />
                              ) : (
                                (() => {
                                  const hasBeneficiaryService =
                                    services?.includes("ABeneficiaryTxn");
                                  const hasInternalService =
                                    services?.includes("AInternalTxn");
                                  // const hasReimbursementService =
                                  //   services?.includes("AReimbursementTxn");
                                  // const hasReimbursementRequestService =
                                  //   services?.includes("AReimbursementRequest");
                                  // const hasFieldForceService =
                                  //   services?.includes("AFieldForceTxn");
                                  // const hasFieldForceRequestService =
                                  //   services?.includes("AFieldForceRequest");
                                  // const hasPrivateService = services?.includes(
                                  //   "APrivateTransaction",
                                  // );
                                  // const hasTaxService =
                                  //   services?.includes("ATDSTransaction");

                                  if (
                                    !hasBeneficiaryService &&
                                    !hasInternalService
                                    // &&
                                    // !hasFieldForceRequestService &&
                                    // !hasFieldForceService &&
                                    // !hasReimbursementService &&
                                    // !hasReimbursementRequestService &&
                                    // !hasPrivateService &&
                                    // !hasTaxService
                                  ) {
                                    return "N/A";
                                  }

                                  const txnTotalCount =
                                    Number(
                                      hasBeneficiaryService &&
                                        beneficiaryTxnCount
                                        ? beneficiaryTxnCount
                                        : GlobalConfiguration.lengthCheckZero,
                                    ) +
                                    Number(
                                      hasInternalService && internalTxnCount
                                        ? internalTxnCount
                                        : GlobalConfiguration.lengthCheckZero,
                                    );
                                  // +
                                  // Number(
                                  //   hasReimbursementService &&
                                  //     reimbursementTxnCount
                                  //     ? reimbursementTxnCount
                                  //     : GlobalConfiguration.lengthCheckZero,
                                  // ) +
                                  // Number(
                                  //   hasReimbursementRequestService &&
                                  //     reimbursementRequestCount
                                  //     ? reimbursementRequestCount
                                  //     : GlobalConfiguration.lengthCheckZero,
                                  // ) +
                                  // Number(
                                  //   hasFieldForceService && fieldForceTnxCount
                                  //     ? fieldForceTnxCount
                                  //     : GlobalConfiguration.lengthCheckZero,
                                  // ) +
                                  // Number(
                                  //   hasFieldForceRequestService &&
                                  //     fieldForceRequestTnxCount
                                  //     ? fieldForceRequestTnxCount
                                  //     : GlobalConfiguration.lengthCheckZero,
                                  // ) +
                                  // Number(
                                  //   hasPrivateService && privateTnxCount
                                  //     ? privateTnxCount
                                  //     : GlobalConfiguration.lengthCheckZero,
                                  // ) +
                                  // Number(
                                  //   hasTaxService && taxTransactionCount
                                  //     ? taxTransactionCount
                                  //     : GlobalConfiguration.lengthCheckZero,
                                  // );

                                  return txnTotalCount <
                                    GlobalConfiguration.panLength
                                    ? txnTotalCount
                                        .toString()
                                        .padStart(
                                          GlobalConfiguration.lengthCheckTwo,
                                          "0",
                                        )
                                    : txnTotalCount.toLocaleString("en-IN");
                                })()
                              )}
                            </>
                          ),
                          desc: "Manage created transactions and requests",
                          type: "approve",
                          txnRequiredServices: [
                            "ABeneficiaryTxn",
                            "AInternalTxn",
                            "AFieldForceRequest",
                            "AFieldForceTxn",
                            // "AReimbursementTxn",
                            // "AReimbursementRequest",
                            // "APrivateTransaction",
                            // "ATDSTransaction",
                          ],
                        },
                      ].map((item, index) => {
                        // Uncomment the above code if u dont want toast
                        // const isTxnServiceAvailable =
                        //   item?.txnRequiredServices.some((service) =>
                        //     services?.includes(service),
                        //   );
                        const isTxnServiceAvailable = item?.comingSoon
                          ? false
                          : item?.txnRequiredServices?.some((service) =>
                              services?.includes(service),
                            );

                        return (
                          <div key={index}>
                            <div
                              className={`w-full flex-1 relative z-z-index-base bg-primary-nav flex Qsmd:flex-col flex-row flex-shrink-0 items-center Qsmd:justify-center text-center px-padding-md Qsmd:py-padding-lg py-padding-sm h-full ${
                                isTxnServiceAvailable
                                  ? "cursor-pointer global-hover-white"
                                  : "cursor-not-allowed"
                              }`}
                              onClick={() => {
                                // If u dont want toast remove this code for receive only
                                if (item?.comingSoon) {
                                  toast.info(
                                    "Feature coming soon",
                                    toast_position,
                                  );
                                  return;
                                }

                                if (isTxnServiceAvailable) {
                                  setTxnLevel1Key(item?.type);
                                  setTxnActiveLevel(
                                    GlobalConfiguration.lengthCheckOne,
                                  );
                                  setLevel1ActiveSlide(
                                    GlobalConfiguration.lengthCheckZero,
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService:
                                        item?.txnRequiredServices,
                                    },
                                  });
                                }
                              }}
                            >
                              <img
                                src={item?.img}
                                alt={
                                  typeof item?.title === "string"
                                    ? item?.title
                                    : "Txn"
                                }
                                className={`w-icon-lg h-icon-lg Qsmd:mb-margin-xs ${!isTxnServiceAvailable && "opacity-light-opacity"}`}
                              />
                              <div
                                className={`Qsmd:ml-margin-base ml-margin-sm flex flex-col Qsmd:items-center items-start ${!isTxnServiceAvailable && "opacity-light-opacity"}`}
                              >
                                <p className="text-font-md Qsmd:text-font-md font-semibold text-text-primary pb-padding-xs flex items-center">
                                  {isNaN(item?.title)
                                    ? item?.title
                                    : Number(item?.title).toLocaleString(
                                        "en-IN",
                                      )}
                                </p>

                                <div className="text-font-xs text-text-secondary">
                                  {item?.desc.split(" ").slice(0, 2).join(" ")}
                                  &nbsp;
                                  <br className="hidden Qsmd:block" />
                                  {item?.desc
                                    .split(" ")
                                    .slice(GlobalConfiguration.lengthCheckTwo)
                                    .join(" ")}
                                </div>
                              </div>
                            </div>

                            {index < GlobalConfiguration.lengthCheckTwo && (
                              <div
                                className={`flex Qsmd:block absolute z-z-index-content Qsmd:top-top-half transform Qsmd:-translate-y-1/2 Qsmd:h-height-lg w-slider-items-seperator-line-width Qsmd:w-auto ml-margin-md Qsmd:ml-margin-base border-t-border Qsmd:border-t-border-base Qsmd:border-r-border border-primary-bg ${
                                  index === GlobalConfiguration.lengthCheckZero
                                    ? "Qsmd:left-1/3"
                                    : "Qsmd:left-2/3"
                                }`}
                              ></div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* PANE 1: Level 1 options (Pay/Receive/Approve items) */}
                  <div className="z-z-index-content w-1/3 relative bg-primary-nav transition-transform duration-animation-medium flex items-center justify-center flex-shrink-0">
                    <div className="relative w-width-full h-height-full overflow-hidden">
                      {txnLevel1Key === "approve" &&
                      (beneficiaryTransactionsViewAllLoading ||
                        internalTransactionsViewAllLoading ||
                        // reimbursementTxnViewAllLoading ||
                        // fieldForceRequestApprovalLoading ||
                        // reimbursementRequestApprovalLoading ||
                        // fieldForceTxnViewAllLoading ||
                        // allPrivateTransactionsLoading ||
                        // taxTransactionViewAllLoading ||
                        txnCountLoading) ? (
                        <div className="flex items-center justify-center w-width-full h-height-full">
                          <img
                            className="w-icon-lg h-icon-lg"
                            src={ICONS?.LOADER_GIF}
                            alt="Loading..."
                          />
                        </div>
                      ) : (
                        <div
                          className="flex h-height-full transition-transform duration-animation-medium ease-in-out w-full"
                          style={{
                            transform: `translateX(-${level1ActiveSlide * PaginationConfiguration.paginationBig}%)`,
                          }}
                        >
                          {level1Slides.map((slideItems, slideIndex) => (
                            <div
                              key={slideIndex}
                              className="w-full flex-shrink-0"
                            >
                              <div
                                className={`flex flex-col Qsmd:grid h-height-full ${
                                  slideItems.length === 1
                                    ? "Qsmd:grid-cols-1"
                                    : slideItems.length === 2
                                      ? "Qsmd:grid-cols-2"
                                      : "Qsmd:grid-cols-3"
                                } text-center Qsmd:justify-start`}
                              >
                                {slideItems.map((item, index) => {
                                  const isLastItem =
                                    index ===
                                    slideItems.length -
                                      GlobalConfiguration.lengthCheckOne;
                                  const isTxnServiceAvailable = Array.isArray(
                                    item?.service,
                                  )
                                    ? item.service.some((s) =>
                                        services?.includes(s),
                                      )
                                    : services?.includes(item?.service);

                                  const txnCount =
                                    item?.title?.match(/\d+/)?.[
                                      GlobalConfiguration.lengthCheckZero
                                    ];
                                  const isTxnCountValid =
                                    txnLevel1Key === "approve"
                                      ? Number(txnCount) >=
                                        GlobalConfiguration.lengthCheckZero
                                      : true;
                                  const isCardTxnEnabled =
                                    isTxnServiceAvailable && isTxnCountValid;

                                  return (
                                    <div
                                      key={index}
                                      className="w-full relative Qsmd:h-height-full"
                                    >
                                      <div
                                        className={`Qsmd:bg-primary-nav relative h-height-full z-z-index-base flex gap-gap-xs Qsmd:flex-col flex-row items-center Qsmd:justify-between text-center px-padding-md Qsmd:px-padding-base py-padding-sm Qsmd:py-padding-lg ${
                                          !isCardTxnEnabled
                                            ? "opacity-light-opacity cursor-not-allowed"
                                            : "opacity-base-opacity cursor-pointer global-hover-white"
                                        }`}
                                        onClick={() => {
                                          if (isCardTxnEnabled) {
                                            if (item?.navigateToSlider) {
                                              setTxnLevel2Key(
                                                item.navigateToSlider,
                                              );
                                              setTxnActiveLevel(
                                                GlobalConfiguration.lengthCheckTwo,
                                              );
                                              setLevel2ActiveSlide(
                                                GlobalConfiguration.lengthCheckZero,
                                              );
                                            } else {
                                              navigate(item?.navigateTo);
                                              sessionStorage.removeItem(
                                                "recreate_ben",
                                              );
                                            }
                                          } else if (!isTxnServiceAvailable) {
                                            const unavailableStr =
                                              Array.isArray(item?.service)
                                                ? item.service.join(", ")
                                                : item?.service;
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService:
                                                  unavailableStr,
                                              },
                                            });
                                          }
                                        }}
                                      >
                                        {item?.img && (
                                          <img
                                            src={item?.img}
                                            alt={item?.title}
                                            className="w-icon-lg h-icon-lg"
                                          />
                                        )}

                                        <div className="ml-margin-sm Qsmd:ml-margin-base flex flex-col gap-gap-xs Qsmd:items-center items-start px-padding-xs">
                                          <p className="text-font-md font-semibold text-text-primary">
                                            {item?.title}
                                          </p>
                                          {item?.desc && (
                                            <p className="text-font-xs Qsmd:px-padding-md text-text-secondary leading-tight Qsmd:text-center text-left">
                                              {item?.desc}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                      {!isLastItem && (
                                        <div
                                          className={`flex Qsmd:block absolute Qsmd:top-top-half Qsmd:-translate-y-1/2 Qsmd:h-height-lg w-slider-items-seperator-line-width Qsmd:w-auto ml-margin-md Qsmd:ml-margin-base border-t-border Qsmd:border-t-border-base Qsmd:border-r-border border-primary-bg Qsmd:right-right-base`}
                                        />
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* PANE 2: Level 2 options (Nested approvals) */}
                  <div className="z-z-index-content w-1/3 relative bg-primary-nav transition-transform duration-animation-medium flex items-center justify-center flex-shrink-0">
                    <div className="relative w-width-full h-height-full overflow-hidden">
                      {txnLevel1Key === "approve" &&
                      (beneficiaryTransactionsViewAllLoading ||
                        internalTransactionsViewAllLoading ||
                        // reimbursementTxnViewAllLoading ||
                        // fieldForceRequestApprovalLoading ||
                        // reimbursementRequestApprovalLoading ||
                        // fieldForceTxnViewAllLoading ||
                        // allPrivateTransactionsLoading ||
                        // taxTransactionViewAllLoading ||
                        txnCountLoading) ? (
                        <div className="flex items-center justify-center w-width-full h-height-full">
                          <img
                            className="w-icon-lg h-icon-lg"
                            src={ICONS?.LOADER_GIF}
                            alt="Loading..."
                          />
                        </div>
                      ) : (
                        <div
                          className="flex h-height-full transition-transform duration-animation-medium ease-in-out w-full"
                          style={{
                            transform: `translateX(-${level2ActiveSlide * PaginationConfiguration.paginationBig}%)`,
                          }}
                        >
                          {level2Slides.map((slideItems, slideIndex) => (
                            <div
                              key={slideIndex}
                              className="w-full flex-shrink-0"
                            >
                              <div
                                className={`flex flex-col Qsmd:grid h-height-full ${
                                  slideItems.length === 1
                                    ? "Qsmd:grid-cols-1"
                                    : slideItems.length === 2
                                      ? "Qsmd:grid-cols-2"
                                      : "Qsmd:grid-cols-3"
                                } text-center Qsmd:justify-start`}
                              >
                                {slideItems.map((item, index) => {
                                  const isLastItem =
                                    index ===
                                    slideItems.length -
                                      GlobalConfiguration.lengthCheckOne;
                                  const isTxnServiceAvailable = Array.isArray(
                                    item?.service,
                                  )
                                    ? item.service.some((s) =>
                                        services?.includes(s),
                                      )
                                    : services?.includes(item?.service);

                                  const isTxnCountValid = true;
                                  const isCardTxnEnabled =
                                    isTxnServiceAvailable && isTxnCountValid;

                                  return (
                                    <div
                                      key={index}
                                      className="w-full relative Qsmd:h-height-full"
                                    >
                                      <div
                                        className={`Qsmd:bg-primary-nav relative h-height-full z-z-index-base flex gap-gap-xs Qsmd:flex-col flex-row items-center Qsmd:justify-center text-center px-padding-md Qsmd:px-padding-base py-padding-sm Qsmd:py-padding-lg ${
                                          !isCardTxnEnabled
                                            ? "opacity-light-opacity cursor-not-allowed"
                                            : "opacity-base-opacity cursor-pointer global-hover-white"
                                        }`}
                                        onClick={() => {
                                          if (isCardTxnEnabled) {
                                            if (item?.navigateToSlider) {
                                              setTxnLevel2Key(
                                                item.navigateToSlider,
                                              );
                                              setTxnActiveLevel(2);
                                              setLevel2ActiveSlide(0);
                                            } else {
                                              navigate(item?.navigateTo);
                                              sessionStorage.removeItem(
                                                "recreate_ben",
                                              );
                                            }
                                          } else if (!isTxnServiceAvailable) {
                                            const unavailableStr =
                                              Array.isArray(item?.service)
                                                ? item.service.join(", ")
                                                : item?.service;
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService:
                                                  unavailableStr,
                                              },
                                            });
                                          }
                                        }}
                                      >
                                        {item?.img && (
                                          <img
                                            src={item?.img}
                                            alt={item?.title}
                                            className="w-icon-lg h-icon-lg"
                                          />
                                        )}

                                        <div className="ml-margin-sm Qsmd:ml-margin-base flex flex-col gap-gap-xs Qsmd:items-center items-start px-padding-xs">
                                          <p className="text-font-md font-semibold text-text-primary">
                                            {item?.title}
                                          </p>
                                          {item?.desc && (
                                            <p className="text-font-xs Qsmd:px-padding-md text-text-secondary leading-tight Qsmd:text-center text-left">
                                              {item?.desc}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                      {!isLastItem && (
                                        <div
                                          className={`flex Qsmd:block absolute Qsmd:top-top-half Qsmd:-translate-y-1/2 Qsmd:h-height-lg w-slider-items-seperator-line-width Qsmd:w-auto ml-margin-md Qsmd:ml-margin-base border-t-border Qsmd:border-t-border-base Qsmd:border-r-border border-primary-bg Qsmd:right-right-base`}
                                        />
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-width-full bg-primary-nav rounded-border-radius-md">
              <h2 className="bg-primary-card flex items-center justify-between px-padding-md py-padding-sm text-font-sm font-semibold text-text-secondary transition-all duration-animation-fast rounded-t-border-radius-md">
                <span className="flex items-center">
                  <img
                    src={ICONS?.STATISTICS}
                    alt="Statistics Header"
                    className="w-icon-sm h-icon-sm mr-margin-sm"
                  />
                  {/* -----header------ */}
                  {widgets.length > GlobalConfiguration.lengthCheckZero
                    ? dynamicTitle
                    : "Statistics"}
                </span>

                {widgets.length > GlobalConfiguration.lengthCheckOne && (
                  <div className="w-icon-lg flex items-center gap-gap-xs">
                    <div
                      onClick={prevSlide}
                      className={`cursor-pointer w-icon-sm h-icon-sm ${
                        currentSlide === GlobalConfiguration.lengthCheckZero
                          ? "opacity-light-opacity cursor-not-allowed"
                          : ""
                      }`}
                      style={{
                        pointerEvents:
                          currentSlide === GlobalConfiguration.lengthCheckZero
                            ? "none"
                            : "auto",
                      }}
                    >
                      <img
                        src={ICONS?.ARROW_LEFT_WHITE_CIRCLE}
                        alt="Previous"
                      />
                    </div>
                    <div
                      onClick={nextSlide}
                      className={`cursor-pointer w-icon-sm h-icon-sm ${
                        currentSlide ===
                        widgets.length - GlobalConfiguration.lengthCheckOne
                          ? "opacity-light-opacity cursor-not-allowed"
                          : ""
                      }`}
                      style={{
                        pointerEvents:
                          currentSlide ===
                          widgets.length - GlobalConfiguration.lengthCheckOne
                            ? "none"
                            : "auto",
                      }}
                    >
                      <img
                        src={ICONS?.ARROW_RIGHT_WHITE_CIRCLE}
                        alt="Next"
                      />
                    </div>
                  </div>
                )}
              </h2>

              <div
                className="relative w-width-full  duration-animation-fast ease-in-out"
                style={{ height: containerHeight }}
              >
                <div className="relative w-width-full overflow-x-clip ">
                  {widgets.length > GlobalConfiguration.lengthCheckZero ? (
                    <div
                      className="flex item-start transition-transform duration-animation-fast ease-in-out"
                      style={{
                        transform: `translateX(-${currentSlide * PaginationConfiguration.paginationBig}%)`,
                      }}
                    >
                      {widgets.map((widget, index) => (
                        <div
                          key={widget.widget_id}
                          ref={(el) => (slideRefs.current[index] = el)}
                          className={`w-width-full flex-shrink-0 ${index === currentSlide ? "" : "overflow-hidden"}`}
                          style={{ height: containerHeight }}
                        >
                          {/* LAZY LOAD: Render component ONLY if slide index was visited to prevent extra api calls for non-visited slides */}
                          {visitedWidgetSlides.has(index) ? (
                            renderWidget(widget)
                          ) : (
                            <div className="w-width-full bg-primary-card rounded-b-border-radius-md h-[var(--remindercard-max-height)]">
                              {" "}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : loading ? (
                    <div className="flex items-center justify-center w-width-full bg-primary-card rounded-b-border-radius-md h-[var(--remindercard-max-height)]">
                      {" "}
                      <img
                        className="w-icon-xl h-icon-xl"
                        src={ICONS?.LOADER_GIF}
                        alt="Loading..."
                      />
                    </div>
                  ) : !loading &&
                    widgets.length === GlobalConfiguration.lengthCheckZero ? (
                    <div className="flex flex-col items-center justify-center lg:justify-start h-full text-center p-padding-md">
                      <div className="flex flex-col justify-center items-center w-width-full">
                        <img
                          src={ICONS?.NO_STATISTICS_AVAILABLE}
                          alt="No Slides"
                          className="w-width-md h-height-md max-h-max-height-top-slider mb-padding-md"
                        />
                        <p className="text-font-xs text-text-primary py-padding-md">
                          Click below to open the statistics page, then select
                          ‘Add to home screen.’
                          <br />
                          Added stats will appear here.
                        </p>
                        <PrimaryWithIconButton
                          icon={ICONS?.ADD_BUTTON_WHITE}
                          imgColor="var(--text-primary)"
                          btnText=" Add statistics"
                          handleFunction={AddStatistics}
                          enabledBgColor="var(--primary-nav-act)"
                          enabledTextColor="var(--text-primary)"
                          hoverOption="white"
                          isDisabled={false}
                          iconToBeAlign="left"
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:max-w-[var(--dashboard-right-card-width)] w-width-full Qsmd:w-width-sm gap-y-gap-md">
            {/* Calender */}
            <div className="w-width-full bg-primary-card lg:w-balance-summary-width rounded-border-radius-md flex flex-col relative">
              <div className="flex gap-gap-sm items-center bg-primary-card rounded-t-border-radius-md py-padding-sm relative border-b border-primary-bg mx-margin-md">
                <SVGComponent
                  url={ICONS?.CALENDER}
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                  color={"var(--text-primary)"}
                />
                <div className="text-font-sm font-semibold text-text-primary">
                  Upcoming Bank Holidays - {new Date().getFullYear()}
                </div>
              </div>

              <div className="w-width-full px-padding-md py-padding-sm flex flex-col gap-gap-sm">
                <div>
                  {holidays.length > GlobalConfiguration.lengthCheckZero ? (
                    <>
                      <p className="text-font-lg pb-padding-xs font-semibold text-text-primary">
                        <span>{formattedDate}</span>
                      </p>

                      <p className="text-font-xxs font-semibold truncate overflow-hidden text-text-secondary">
                        {`${new Date(
                          holidays[GlobalConfiguration.lengthCheckZero].date,
                        )
                          .toLocaleDateString("en-US", { weekday: "long" })
                          .slice(
                            GlobalConfiguration.lengthCheckZero,
                            3,
                          )} - ${getHolidayLabel(holidays[GlobalConfiguration.lengthCheckZero])}`}
                      </p>
                    </>
                  ) : (
                    <p className="text-font-sm text-text-primary">
                      No upcoming holidays this month.
                    </p>
                  )}
                </div>

                <div className="flex justify-end">
                  <PrimaryWithIconButton
                    btnText="View more"
                    handleFunction={() => {
                      if (
                        holidays.length !== GlobalConfiguration.lengthCheckZero
                      ) {
                        setIsCalendarOpen(true);
                        dispatch(toggleCalendar(true));
                        setIsCalendarOpenScroll(true);
                      }
                    }}
                    icon={ICONS?.ARROW_DOWN_WHITE}
                    enabledBgColor="var(--primary-nav-act)"
                    enabledTextColor="var(--text-primary)"
                    imgColor="var(--text-primary)"
                    hoverOption="white"
                    isDisabled={
                      holidays.length === GlobalConfiguration.lengthCheckZero
                    }
                    iconToBeAlign="right"
                  />
                </div>

                {/* <div className="calenderMob"> */}
                <div
                  className="fixed top-top-base left-left-base w-screen h-screen flex z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity"
                  style={{ display: isCalendarOpen ? "block" : "none" }}
                  onClick={() => {
                    setIsCalendarOpen(false);
                    dispatch(toggleCalendar(false));
                  }}
                ></div>
                <div className={`absolute z-z-index-modal inset-0 h-0`}>
                  <div
                    className={`bg-primary-card rounded-border-radius-md shadow-lg w-width-full max-w-md hidden Qsmd:flex flex-col ${
                      isCalendarOpen ? "h-auto block" : "none"
                    } relative ${showHolidayModalBannerOffset ? "modal-banner" : "inset-0"} flex ${
                      isCalendarOpen === true
                        ? "opened"
                        : isCalendarOpen === false
                          ? "closed"
                          : "defaultclose"
                    }
`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flex gap-gap-sm items-center rounded-t-border-radius-md py-padding-sm border-b border-primary-bg mx-margin-md relative">
                      <SVGComponent
                        url={ICONS?.CALENDER}
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                        color={"var(--text-primary)"}
                      />
                      <div className="text-font-sm font-semibold text-text-primary">
                        Upcoming Bank Holidays - {new Date().getFullYear()}
                      </div>
                    </div>
                    <div
                      ref={calendarScrollRef}
                      className="overflow-y-auto bg-primary-card"
                      style={{
                        height: showHolidayModalBannerOffset
                          ? "calc(var(--home-modal-height-content) - var(--home-modal-offset-base))"
                          : "calc(var(--home-modal-height-content) - var(--home-modal-offset-banner))",
                      }}
                    >
                      {Object.keys(holidaysByMonth).map((month, index) => {
                        const isOpen = openMonth === month;
                        const isLast =
                          index ===
                          Object.keys(holidaysByMonth).length -
                            GlobalConfiguration.lengthCheckOne;
                        return (
                          <>
                            <div
                              key={month}
                              className={`overflow-hidden ${isLast ? "" : "border-b border-primary-bg"} mx-margin-sm`}
                            >
                              {/* Month Header */}
                              <div className="w-width-full py-padding-sm">
                                <div
                                  onClick={() => {
                                    toggleMonth(month);
                                  }}
                                  className="w-width-full bg-primary-card global-hover-white rounded-border-radius-md text-font-sm flex items-center justify-between relative z-z-index-base p-padding-sm cursor-pointer"
                                >
                                  <span className="text-text-primary">
                                    {month}
                                  </span>

                                  {/* Arrow */}
                                  <div
                                    className={`transition-transform duration-animation-fast ${
                                      isOpen ? "rotate-half" : "rotate-base"
                                    }`}
                                  >
                                    <SVGComponent
                                      url={ICONS?.ARROW_DOWN_WHITE}
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                      color={"var(--text-primary)"}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Accordion Content */}
                              <div
                                className={`grid transition-all duration-animation-fast ease-in-out bg-primary-card px-padding-sm ${
                                  isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                                }`}
                              >
                                <div className="overflow-hidden">
                                  {holidaysByMonth[month].map(
                                    (holiday, index) => (
                                      <div key={holiday.id}>
                                        <HolidayCard
                                          index={index}
                                          date={holiday.date}
                                          occasion={holiday.occasion}
                                        />

                                        {index <
                                          holidaysByMonth[month].length -
                                            GlobalConfiguration.lengthCheckOne && (
                                          <div className="border-t border-primary-bg" />
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                    <div className="absolute bottom-bottom-base flex justify-end py-padding-sm px-padding-md w-width-full bg-primary-card rounded-b-border-radius-md">
                      <PrimaryWithIconButton
                        btnText="View less"
                        handleFunction={() => {
                          setOpenMonth(null);
                          setIsCalendarOpen(false);
                          dispatch(toggleCalendar(false));
                          setOpenMonth(currentMonth);
                          setIsCalendarOpenScroll(false);
                        }}
                        icon={ICONS?.ARROW_UP_WHITE}
                        enabledBgColor="var(--primary-nav-act)"
                        enabledTextColor="var(--text-primary)"
                        imgColor="var(--text-primary)"
                        hoverOption="white"
                        iconToBeAlign="right"
                      />
                    </div>
                    <div className="h-mobile-navbar-height flex-shrink-0"></div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>

            {isCalendarOpen && (
              <div
                className="calenderWebPopUp Qsmd:hidden block"
                onClick={() => setIsCalendarOpen(false)}
              >
                <div className="fixed top-top-base left-left-base w-screen h-screen flex z-z-index-fixed-ui bg-custom-backdrop bg-opacity-dark-opacity"></div>
                <div className="inset-0 flex justify-center items-center z-z-index-modal absolute px-padding-md Qsm:px-padding-base">
                  <div
                    className={`bg-primary-card rounded-border-radius-md shadow-lg w-width-full max-w-[var(--max-width-holiday-calendar)] flex flex-col origin-top ${
                      isCalendarOpen ? "h-auto block" : "none"
                    } relative flex Qmd:animate-none animate-slideInFromRight max-h-[var(--home-modal-height-end)]`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flex gap-gap-sm items-center rounded-t-border-radius-md py-padding-sm border-b border-primary-bg mx-margin-md relative">
                      <SVGComponent
                        url={ICONS?.CALENDER}
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                        color={"var(--text-primary)"}
                      />
                      <div className="text-font-sm font-semibold text-text-primary">
                        Upcoming Bank Holidays - {new Date().getFullYear()}
                      </div>
                    </div>
                    <div
                      ref={calendarScrollRef}
                      className="overflow-y-auto bg-primary-card"
                      style={{
                        height: showHolidayModalBannerOffset
                          ? "calc(var(--home-modal-height-content) - var(--home-modal-offset-base))"
                          : "calc(var(--home-modal-height-content) - var(--home-modal-offset-banner))",
                      }}
                    >
                      {Object.keys(holidaysByMonth).map((month, index) => {
                        const isOpen = openMonth === month;
                        const isLast =
                          index ===
                          Object.keys(holidaysByMonth).length -
                            GlobalConfiguration.lengthCheckOne;
                        return (
                          <>
                            <div
                              key={month}
                              className={`overflow-hidden ${isLast ? "" : "border-b border-primary-bg"} mx-margin-sm`}
                            >
                              {/* Month Header */}
                              <div className="w-width-full py-padding-sm">
                                <div
                                  onClick={() => {
                                    toggleMonth(month);
                                  }}
                                  className="w-width-full bg-primary-card global-hover-white rounded-border-radius-md text-font-sm flex items-center justify-between relative z-z-index-base p-padding-sm cursor-pointer"
                                >
                                  <span className="text-text-primary">
                                    {month}
                                  </span>

                                  {/* Arrow */}
                                  <div
                                    className={`transition-transform duration-animation-fast ${
                                      isOpen ? "rotate-half" : "rotate-base"
                                    }`}
                                  >
                                    <SVGComponent
                                      url={ICONS?.ARROW_DOWN_WHITE}
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                      color={"var(--text-primary)"}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Accordion Content */}
                              <div
                                className={`grid transition-all duration-animation-fast ease-in-out bg-primary-card px-padding-sm ${
                                  isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                                }`}
                              >
                                <div className="overflow-hidden">
                                  {holidaysByMonth[month].map(
                                    (holiday, index) => (
                                      <div key={holiday.id}>
                                        <HolidayCard
                                          index={index}
                                          date={holiday.date}
                                          occasion={holiday.occasion}
                                        />

                                        {index <
                                          holidaysByMonth[month].length -
                                            GlobalConfiguration.lengthCheckOne && (
                                          <div className="border-t border-primary-bg" />
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                    <div className="absolute bottom-bottom-base flex justify-end py-padding-sm px-padding-md w-width-full bg-primary-card rounded-b-border-radius-md">
                      <PrimaryWithIconButton
                        btnText="View less"
                        handleFunction={() => {
                          setOpenMonth(null);
                          setIsCalendarOpen(false);
                          dispatch(toggleCalendar(false));
                          setOpenMonth(currentMonth);
                        }}
                        icon={ICONS?.ARROW_UP_WHITE}
                        enabledBgColor="var(--primary-nav-act)"
                        enabledTextColor="var(--text-primary)"
                        imgColor="var(--text-primary)"
                        hoverOption="white"
                        iconToBeAlign="right"
                      />
                    </div>
                    <div className="h-mobile-navbar-height flex-shrink-0"></div>
                  </div>
                </div>
              </div>
            )}

            <div className="w-width-full bg-primary-card lg:w-balance-summary-width  rounded-border-radius-md relative overflow-hidden">
              <div className="flex bg-primary-card rounded-t-border-radius-md ">
                <div
                  className={`relative py-padding-sm ${
                    openAccountSlider
                      ? "global-hover-white z-z-index-base cursor-pointer"
                      : ""
                  }`}
                  onClick={() => setOpenAccountSlider(null)}
                >
                  <div
                    className={`relative h-height-full border-primary-bg border-r-border top-top-base left-left-base flex items-center transition-all duration-animation-medium ${
                      openAccountSlider
                        ? "w-home-dashboard-back-arrow-width-slider"
                        : "w-width-base border-primary-card"
                    }`}
                  >
                    <div className="ml-margin-md">
                      <SVGComponent
                        url={ICONS?.ARROW_LEFT_WHITE}
                        color="var(--text-primary)"
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className={`w-full flex justify-between items-center px-padding-sm pl-padding-md py-padding-sm lg:py-padding-base my-margin-base lg:my-margin-sm transition-all duration-animation-medium ${
                    openAccountSlider
                      ? "rounded-tr-border-radius-md"
                      : "border-primary-bg"
                  }`}
                >
                  <div className="flex items-center gap-gap-sm">
                    <img
                      src={ICONS?.ACCOUNT_UNSELECTED}
                      alt="transcation header"
                      className="w-icon-sm h-icon-sm"
                    />
                    <span className="text-font-sm font-semibold text-text-primary ">
                      {!openAccountSlider
                        ? "Accounts"
                        : openAccountSlider === "create"
                          ? "Create"
                          : openAccountSlider === "approve"
                            ? "Approve"
                            : "Transactions"}
                    </span>
                  </div>

                  <div
                    className={`flex gap-gap-sm mr-margin-sm transition-all duration-animation-medium ${(openAccountSlider || openAccountSlider === "approve") && accSlides.length > GlobalConfiguration.lengthCheckOne ? "opacity-base-opacity" : "opacity-opacity-none cursor-default"}`}
                  >
                    <div
                      onClick={() => {
                        if (
                          accActiveSlide === GlobalConfiguration.lengthCheckZero
                        )
                          return;
                        setAccActiveSlide(
                          (p) => p - GlobalConfiguration.lengthCheckOne,
                        );
                      }}
                      className={`${accActiveSlide === GlobalConfiguration.lengthCheckZero ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer"} ${openAccountSlider || openAccountSlider === "approve" ? "" : "cursor-default"}`}
                    >
                      <SVGComponent
                        url={ICONS?.ARROW_LEFT_WHITE_CIRCLE}
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                    <div
                      onClick={() => {
                        if (
                          accActiveSlide ===
                          accSlides.length - GlobalConfiguration.lengthCheckOne
                        )
                          return;
                        setAccActiveSlide(
                          (p) => p + GlobalConfiguration.lengthCheckOne,
                        );
                      }}
                      className={`${accActiveSlide === accSlides.length - GlobalConfiguration.lengthCheckOne ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer"} ${openAccountSlider || openAccountSlider === "approve" ? "" : "cursor-default"}`}
                    >
                      <SVGComponent
                        url={ICONS?.ARROW_RIGHT_WHITE_CIRCLE}
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative bg-primary-nav w-width-full overflow-hidden">
                <div
                  className={`flex w-width-double transition-transform duration-animation-medium ease-in-out ${openAccountSlider ? "-translate-x-1/2" : "translate-x-0"}`}
                >
                  <div className="grid grid-cols-1 relative flex-shrink-0 w-width-md">
                    {[
                      {
                        img: ICONS?.CREATE_ACCOUNT_WITH_CIRCLE,
                        title: "Create",
                        desc: "Create an account",
                        type: "create",
                        accountRequiredServices: [
                          "BUAccount",
                          "FFUAccount",
                          "REUAccount",
                        ],
                      },
                      {
                        img: ICONS?.APPROVE_WITH_BLUE_CIRCLE,
                        title: (
                          <>
                            Approve -&nbsp;
                            {getAllBeneficiaryAccountsLoading ||
                            getAllInternalAccountLoading ||
                            remitterAccountViewAllLoading ||
                            // ReimburseViewAllHomeDashboardLoading ||
                            accountCountLoading ? (
                              <img
                                src={ICONS?.LOADER_GIF}
                                alt="Loading..."
                                className="h-icon-sm inline-block"
                              />
                            ) : (
                              (() => {
                                const hasBeneficiaryService =
                                  services?.includes("BAAccount");
                                const hasInternalService =
                                  services?.includes("IAAccount");
                                const hasFieldForceService =
                                  services?.includes("FFAAccount");

                                // const hasReimbursementService =
                                //   services?.includes("RAAccount");
                                const hasRemitterService =
                                  services?.includes("REAAccount");

                                if (
                                  !hasBeneficiaryService &&
                                  !hasInternalService &&
                                  !hasFieldForceService &&
                                  // &&
                                  // !hasReimbursementService
                                  !hasRemitterService
                                ) {
                                  return "N/A";
                                }

                                const accountTotalCount =
                                  Number(
                                    hasBeneficiaryService &&
                                      beneficiaryAccountCount
                                      ? beneficiaryAccountCount
                                      : GlobalConfiguration.lengthCheckZero,
                                  ) +
                                  Number(
                                    hasInternalService && internalAccountCount
                                      ? internalAccountCount
                                      : GlobalConfiguration.lengthCheckZero,
                                  ) +
                                  Number(
                                    hasFieldForceService &&
                                      fieldForceAccountCount
                                      ? fieldForceAccountCount
                                      : GlobalConfiguration?.lengthCheckZero,
                                  ) +
                                  // Number(
                                  //   hasReimbursementService &&
                                  //     reimbursementAccCount
                                  //     ? reimbursementAccCount
                                  //     : GlobalConfiguration.lengthCheckZero,
                                  // ) +
                                  Number(
                                    hasRemitterService && remitterAccountCount
                                      ? remitterAccountCount
                                      : GlobalConfiguration.lengthCheckZero,
                                  );
                                return accountTotalCount <
                                  GlobalConfiguration.panLength
                                  ? accountTotalCount
                                      .toString()
                                      .padStart(
                                        GlobalConfiguration.lengthCheckTwo,
                                        "0",
                                      )
                                  : accountTotalCount.toLocaleString("en-IN");
                              })()
                            )}
                          </>
                        ),
                        desc: "Approve created accounts",
                        type: "approve",
                        accountRequiredServices: [
                          "BAAccount",
                          "IAAccount",
                          // "RAAccount",
                          "REAAccount",
                          "FFAAccount",
                        ],
                      },
                    ].map((item, index) => {
                      const isAccountServiceAvailable =
                        item?.accountRequiredServices.some((service) =>
                          services?.includes(service),
                        );

                      return (
                        <div
                          key={index}
                          className="w-width-full Qsmd:relative"
                        >
                          <div
                            className={`w-width-full gap-gap-sm bg-primary-nav flex relative Qsmd:h-full flex-row items-center text-center px-padding-button-l py-padding-button-l Qsmd:py-padding-md mt-margin-base ${
                              isAccountServiceAvailable
                                ? "opacity-base-opacity cursor-pointer global-hover-white z-z-index-base"
                                : "opacity-light-opacity cursor-not-allowed"
                            }`}
                            onClick={() => {
                              if (isAccountServiceAvailable) {
                                setOpenAccountSlider(item?.type);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService:
                                      item?.accountRequiredServices,
                                  },
                                });
                              }
                            }}
                          >
                            <img
                              src={item?.img}
                              alt={item?.title}
                              className={`w-icon-lg h-icon-lg mb-margin-xs ${
                                !isAccountServiceAvailable &&
                                "opacity-light-opacity"
                              }`}
                            />
                            <div
                              className={`flex flex-col flex-1 items-start ${
                                !isAccountServiceAvailable &&
                                "opacity-light-opacity"
                              }`}
                            >
                              <p className="text-font-md Qsmd:text-font-md font-semibold text-text-primary pb-padding-xs flex items-center">
                                {isNaN(item?.title)
                                  ? item?.title
                                  : Number(item?.title).toLocaleString("en-IN")}
                              </p>

                              <div className="text-font-xs text-text-secondary">
                                {item?.desc.split(" ").slice(0, 3).join(" ")}
                                &nbsp;
                                <br className="hidden Qsmd:block" />
                                {item?.desc.split(" ").slice(3).join(" ")}
                              </div>
                            </div>
                          </div>
                          {index === GlobalConfiguration.lengthCheckZero && (
                            <div
                              className={`flex absolute z-z-index-content transform w-slider-items-seperator-line-width ml-margin-md border-t-border border-primary-bg`}
                            ></div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  <div
                    className={`bottom-[var(--border)] right-right-base w-width-md bg-primary-nav transition-transform duration-animation-medium flex`}
                  >
                    <div
                      className={`flex flex-wrap text-center relative justify-center w-width-full lg:mb-margin-base`}
                    >
                      <div className="relative overflow-hidden w-width-full h-height-full">
                        <div
                          className="flex transition-transform duration-animation-medium ease-in-out h-height-full w-full"
                          style={{
                            transform: `translateX(-${accActiveSlide * 100}%)`,
                          }}
                        >
                          {accSlides.map((slideItems, slideIndex) => (
                            <div
                              key={slideIndex}
                              className="w-full flex-shrink-0"
                            >
                              <div
                                className={`flex flex-col text-center relative items-center  w-width-full h-height-full Qlg:items-start`}
                              >
                                {openAccountSlider === "approve" &&
                                (getAllBeneficiaryAccountsLoading ||
                                  getAllInternalAccountLoading ||
                                  accountCountLoading) ? (
                                  <div className="flex items-center justify-center w-width-full h-height-full">
                                    <img
                                      className="w-icon-lg h-icon-lg"
                                      src={ICONS?.LOADER_GIF}
                                      alt="Loading..."
                                    />
                                  </div>
                                ) : (
                                  slideItems.map((item, index, array) => {
                                    const isLastItem =
                                      index ===
                                      slideItems.length -
                                        GlobalConfiguration.lengthCheckOne;
                                    const isAccountServiceAvailable =
                                      services?.includes(item?.requiredService);

                                    const accountCount =
                                      item?.title?.match(/\d+/)?.[
                                        GlobalConfiguration.lengthCheckZero
                                      ];
                                    const isAccountCountValid =
                                      openAccountSlider === "approve"
                                        ? item?.loading ||
                                          Number(accountCount) >
                                            GlobalConfiguration.lengthCheckZero
                                        : true;

                                    const isCardAccountEnabled =
                                      isAccountServiceAvailable &&
                                      isAccountCountValid;

                                    return (
                                      <div
                                        key={index}
                                        className=" w-width-full relative h-height-md"
                                      >
                                        {/* CARD */}

                                        <div
                                          className={`bg-primary-nav flex flex-row flex-shrink-0 h-height-full items-center text-center px-padding-md py-padding-sm Qsmd:py-padding-md gap-gap-sm transition-all duration-animation-medium relative z-z-index-base ${
                                            !isCardAccountEnabled
                                              ? "opacity-light-opacity cursor-not-allowed"
                                              : "opacity-base-opacity cursor-pointer global-hover-white"
                                          }`}
                                          onClick={() => {
                                            if (item?.loading) {
                                              return;
                                            }
                                            if (isCardAccountEnabled) {
                                              navigate(item?.path);
                                            } else if (!item.requiredService) {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      item?.requiredService,
                                                  },
                                                },
                                              );
                                            }
                                          }}
                                        >
                                          {item?.img && (
                                            <img
                                              src={item?.img}
                                              alt={item?.title}
                                              className="w-icon-lg h-icon-lg Qsmd:mb-margin-xs"
                                            />
                                          )}

                                          <div className="lg:ml-margin-base flex flex-col items-start justify-start">
                                            <p className="w-fit text-font-md font-semibold text-text-primary pb-padding-xs">
                                              {(() => {
                                                if (item?.loading) {
                                                  return (
                                                    <span className="flex items-center gap-gap-xs">
                                                      {item?.title
                                                        ?.toString()
                                                        .replace(
                                                          /\d+|N\/A/,
                                                          "",
                                                        )}
                                                      <img
                                                        src={ICONS?.LOADER_GIF}
                                                        alt="Loading..."
                                                        className="h-icon-sm"
                                                      />
                                                    </span>
                                                  );
                                                }

                                                const match = item?.title.match(
                                                  /^(.+?) - (\d+|N\/A)(.*)$/,
                                                );
                                                if (match) {
                                                  const [
                                                    ,
                                                    label,
                                                    value,
                                                    suffix,
                                                  ] = match;
                                                  if (value === "N/A")
                                                    return `${label} - N/A${suffix}`;

                                                  const number = Number(value);
                                                  const displayValue =
                                                    number ===
                                                    GlobalConfiguration.lengthCheckZero
                                                      ? "00"
                                                      : number <
                                                          GlobalConfiguration.panLength
                                                        ? number
                                                            .toString()
                                                            .padStart(
                                                              GlobalConfiguration.lengthCheckTwo,
                                                              "0",
                                                            )
                                                        : number.toLocaleString(
                                                            "en-IN",
                                                          );

                                                  return (
                                                    <>
                                                      <div className="flex flex-row gap-gap-xs Qmd:gap-gap-base">
                                                        <div className="">
                                                          {label} -&nbsp;
                                                        </div>
                                                        <div>
                                                          {displayValue}
                                                          {suffix}
                                                        </div>
                                                      </div>
                                                    </>
                                                  );
                                                }
                                                return item?.title;
                                              })()}
                                            </p>

                                            {item?.desc && (
                                              <p
                                                className={`text-font-xs text-text-secondary text-start`}
                                              >
                                                {item?.desc}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                        {!isLastItem && (
                                          <div className="flex absolute w-slider-items-seperator-line-width ml-margin-md border-t-border border-primary-bg z-z-index-content"></div>
                                        )}
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BalanceSummary type="home_dashboard" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeDashboard;
